
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2un4A", function(module, exports) {

$parcel$export(module.exports, "TeamContainers", () => $4adb5a7a7d2f1b64$export$73c2d2b9b49926f5);

var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $inPa6 = parcelRequire("inPa6");

var $ccHMk = parcelRequire("ccHMk");

var $c6GJD = parcelRequire("c6GJD");

var $6xdDU = parcelRequire("6xdDU");

var $dh538 = parcelRequire("dh538");

var $cwkWT = parcelRequire("cwkWT");
var $dcJ7R = parcelRequire("dcJ7R");
var $1GzhS = parcelRequire("1GzhS");

var $6fnsQ = parcelRequire("6fnsQ");

var $hbp6S = parcelRequire("hbp6S");

var $cK1S8 = parcelRequire("cK1S8");

var $g1rvx = parcelRequire("g1rvx");

var $hogmh = parcelRequire("hogmh");

var $aYWXT = parcelRequire("aYWXT");

var $kcNH6 = parcelRequire("kcNH6");

var $iTmer = parcelRequire("iTmer");

var $elYMw = parcelRequire("elYMw");

var $fZVE2 = parcelRequire("fZVE2");

var $e9UQf = parcelRequire("e9UQf");
const $4adb5a7a7d2f1b64$export$ebe0b8fe8b6acbfd = `var(--ds-icon-inverse, ${(0, $6fnsQ.N0)})`;
const $4adb5a7a7d2f1b64$export$72502e51aebdd94e = `var(--ds-icon-subtle, ${(0, $6fnsQ.N90)})`;
const $4adb5a7a7d2f1b64$export$33f8090aba665a84 = 4;
const $4adb5a7a7d2f1b64$export$73c2d2b9b49926f5 = ({ teamId: teamId, onAddAContainerClick: onAddAContainerClick, components: components, userId: userId, cloudId: cloudId, filterContainerId: filterContainerId, isDisplayedOnProfileCard: isDisplayedOnProfileCard, maxNumberOfContainersToShow: maxNumberOfContainersToShow = $4adb5a7a7d2f1b64$export$33f8090aba665a84 })=>{
    const isSupportingAddWebLink = (0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).getExperimentValue('team_and_container_web_link', 'isEnabled', false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { teamContainers: teamContainers, loading: loading, unlinkError: unlinkError } = (0, $hogmh.useTeamContainers)(teamId);
    const { teamLinks: teamLinks } = (0, $aYWXT.useTeamLinksAndContainers)(teamId, true);
    const [_, actions] = (0, $hogmh.useTeamContainersHook)();
    const [showMore, setShowMore] = (0, $gwFzn.useState)(false);
    const [isDisconnectDialogOpen, setIsDisconnectDialogOpen] = (0, $gwFzn.useState)(false);
    const [selectedContainerDetails, setSelectedContainerDetails] = (0, $gwFzn.useState)();
    const [filteredTeamContainers, setFilteredTeamContainers] = (0, $gwFzn.useState)(teamContainers);
    const [filteredTeamLinks, setFilteredTeamLinks] = (0, $gwFzn.useState)(teamLinks);
    const [showAddContainer, setShowAddContainer] = (0, $gwFzn.useState)({
        Jira: false,
        Confluence: false,
        Loom: false,
        WebLink: false
    });
    const { fireOperationalEvent: fireOperationalEvent, fireTrackEvent: fireTrackEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { data: productPermissions, loading: productPermissionIsLoading } = (0, $g1rvx.useProductPermissions)({
        userId: userId,
        cloudId: cloudId
    });
    (0, $gwFzn.useEffect)(()=>{
        if (isSupportingAddWebLink) {
            if (isDisplayedOnProfileCard && filterContainerId) setFilteredTeamLinks(teamLinks.filter((container)=>container.id !== filterContainerId));
            else setFilteredTeamLinks(teamLinks);
        } else if (isDisplayedOnProfileCard && filterContainerId) setFilteredTeamContainers(teamContainers.filter((container)=>container.id !== filterContainerId));
        else setFilteredTeamContainers(teamContainers);
    }, [
        teamLinks,
        teamContainers,
        isSupportingAddWebLink,
        isDisplayedOnProfileCard,
        filterContainerId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        const containersToCheck = isSupportingAddWebLink ? filteredTeamLinks : filteredTeamContainers;
        if (containersToCheck.length > maxNumberOfContainersToShow || isDisplayedOnProfileCard) setShowAddContainer({
            Jira: false,
            Confluence: false,
            Loom: false,
            WebLink: false
        });
        else {
            const hasJiraProject = containersToCheck.some((container)=>container.type === 'JiraProject');
            const hasConfluenceSpace = containersToCheck.some((container)=>container.type === 'ConfluenceSpace');
            const hasLoomSpace = containersToCheck.some((container)=>container.type === 'LoomSpace');
            const hasWebLink = containersToCheck.some((container)=>container.type === 'WebLink');
            setShowAddContainer({
                Jira: !hasJiraProject && !!productPermissions && !!(0, $cK1S8.hasProductPermission)(productPermissions, 'jira'),
                Confluence: !hasConfluenceSpace && !!productPermissions && !!(0, $cK1S8.hasProductPermission)(productPermissions, 'confluence'),
                Loom: !hasLoomSpace && !!productPermissions && !!(0, $cK1S8.hasProductPermission)(productPermissions, 'loom'),
                WebLink: !hasWebLink
            });
        }
    }, [
        isDisplayedOnProfileCard,
        productPermissions,
        isSupportingAddWebLink,
        filteredTeamContainers,
        filteredTeamLinks,
        maxNumberOfContainersToShow
    ]);
    const handleShowMore = ()=>{
        setShowMore(!showMore);
    };
    const handleOpenDisconnectDialog = (0, $gwFzn.useCallback)((containerDetails)=>{
        setSelectedContainerDetails(containerDetails);
        setIsDisconnectDialogOpen(true);
        fireTrackEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).OPENED,
            actionSubject: 'unlinkContainerDialog',
            attributes: {
                teamId: teamId
            }
        });
    }, [
        createAnalyticsEvent,
        fireTrackEvent,
        teamId
    ]);
    const LinkedContainerCardComponent = components?.ContainerCard || (0, $elYMw.LinkedContainerCard);
    const handleDisconnect = (0, $gwFzn.useCallback)(async (containerId)=>{
        const removedContainer = filteredTeamContainers.find((container)=>container.id === containerId);
        await actions.unlinkTeamContainers(teamId, containerId);
        setIsDisconnectDialogOpen(false);
        if (unlinkError) fireOperationalEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).FAILED,
            actionSubject: 'teamContainerUnlinked'
        });
        else fireOperationalEvent(createAnalyticsEvent, {
            action: (0, $hbp6S.AnalyticsAction).SUCCEEDED,
            actionSubject: 'teamContainerUnlinked',
            attributes: {
                containerRemoved: {
                    containerId: removedContainer?.id,
                    container: removedContainer?.type
                },
                teamId: teamId
            }
        });
    }, [
        actions,
        createAnalyticsEvent,
        fireOperationalEvent,
        filteredTeamContainers,
        teamId,
        unlinkError
    ]);
    const TeamContainersSkeletonComponent = components?.TeamContainersSkeleton || (0, $e9UQf.TeamContainersSkeleton);
    if (loading || productPermissionIsLoading) return /*#__PURE__*/ (0, $7UHDa.jsx)(TeamContainersSkeletonComponent, {
        numberOfContainers: maxNumberOfContainersToShow
    });
    if ((isSupportingAddWebLink ? filteredTeamLinks.length === 0 : filteredTeamContainers.length === 0) && !isDisplayedOnProfileCard && (!productPermissions || !(productPermissions && ((0, $cK1S8.hasProductPermission)(productPermissions, 'jira') || (0, $cK1S8.hasProductPermission)(productPermissions, 'confluence') || (0, $cK1S8.hasProductPermission)(productPermissions, 'loom'))))) return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $fZVE2.NoProductAccessState), {});
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $7UHDa.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1GzhS.default), {
                space: "space.200",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $cwkWT.default), {
                        templateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
                        gap: isDisplayedOnProfileCard ? 'space.0' : 'space.100',
                        children: [
                            isSupportingAddWebLink ? filteredTeamLinks.slice(0, maxNumberOfContainersToShow).map((container)=>{
                                return /*#__PURE__*/ (0, $7UHDa.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    containerId: container.id,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        })
                                }, container.id);
                            }) : filteredTeamContainers.slice(0, maxNumberOfContainersToShow).map((container)=>{
                                return /*#__PURE__*/ (0, $7UHDa.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    containerId: container.id,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        })
                                }, container.id);
                            }),
                            showAddContainer.Jira && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kcNH6.AddContainerCard), {
                                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Jira'),
                                containerType: "JiraProject"
                            }),
                            showAddContainer.Confluence && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kcNH6.AddContainerCard), {
                                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Confluence'),
                                containerType: "ConfluenceSpace"
                            }),
                            showAddContainer.Loom && (0, $dh538.fg)('loom_tab_in_container_linker_team_profile_page') && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kcNH6.AddContainerCard), {
                                onAddAContainerClick: (e)=>onAddAContainerClick(e, 'Loom'),
                                containerType: "LoomSpace"
                            }),
                            isSupportingAddWebLink && showAddContainer.WebLink && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $kcNH6.AddContainerCard), {
                                onAddAContainerClick: ()=>{},
                                containerType: "WebLink"
                            }),
                            showMore && isSupportingAddWebLink ? filteredTeamLinks.slice(maxNumberOfContainersToShow).map((container)=>{
                                return /*#__PURE__*/ (0, $7UHDa.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerId: container.id,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        })
                                }, container.id);
                            }) : showMore && filteredTeamContainers.slice(maxNumberOfContainersToShow).map((container)=>{
                                return /*#__PURE__*/ (0, $7UHDa.jsx)(LinkedContainerCardComponent, {
                                    containerType: container.type,
                                    containerTypeProperties: container.containerTypeProperties,
                                    title: container.name,
                                    containerId: container.id,
                                    containerIcon: container.icon || undefined,
                                    link: container.link || undefined,
                                    onDisconnectButtonClick: ()=>handleOpenDisconnectDialog({
                                            containerId: container.id,
                                            containerType: container.type,
                                            containerName: container.name
                                        })
                                }, container.id);
                            })
                        ]
                    }),
                    (isSupportingAddWebLink ? filteredTeamLinks.length : filteredTeamContainers.length) > maxNumberOfContainersToShow && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $dcJ7R.default), {
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ccHMk.default), {
                            appearance: "subtle",
                            onClick: handleShowMore,
                            children: showMore ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...$4adb5a7a7d2f1b64$var$messages.showLess
                            }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...$4adb5a7a7d2f1b64$var$messages.showMore
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $6xdDU.default), {
                children: isDisconnectDialogOpen && selectedContainerDetails && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iTmer.DisconnectDialogLazy), {
                    containerName: selectedContainerDetails.containerName,
                    containerType: selectedContainerDetails.containerType,
                    onClose: ()=>setIsDisconnectDialogOpen(false),
                    onDisconnect: ()=>handleDisconnect(selectedContainerDetails.containerId)
                })
            })
        ]
    });
};
const $4adb5a7a7d2f1b64$var$messages = (0, $2nPZH.defineMessages)({
    showMore: {
        id: "ptc-directory.team-profile-page.team-containers.show-more.non-final",
        defaultMessage: "Show more"
    },
    showLess: {
        id: "ptc-directory.team-profile-page.team-containers.show-less.non-final",
        defaultMessage: "Show less"
    }
});

});
parcelRegister("hbp6S", function(module, exports) {

$parcel$export(module.exports, "usePeopleAndTeamAnalytics", () => $f89d3a6c9232b957$export$c673a0f984c6d01b);
$parcel$export(module.exports, "AnalyticsAction", () => $f89d3a6c9232b957$export$30c16f5c43437fd7);

var $iKx9t = parcelRequire("iKx9t");
const $f89d3a6c9232b957$var$ANALYTICS_CHANNEL = 'peopleTeams';
const $f89d3a6c9232b957$var$runItLater = (cb)=>{
    if (window.requestIdleCallback === 'function') return window.requestIdleCallback(cb);
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(cb);
    return ()=>setTimeout(cb);
};
const $f89d3a6c9232b957$export$c673a0f984c6d01b = ()=>{
    const [{ eventAttributes: injectedEventAttributes }] = (0, $iKx9t.usePeopleTeamsAnalyticsSubcontext)();
    const fireEvent = (kind)=>(createAnalyticsEvent, body)=>{
            if (!createAnalyticsEvent) return;
            $f89d3a6c9232b957$var$runItLater(()=>{
                const eventWithSubcontextAttributes = {
                    ...body.attributes,
                    ...injectedEventAttributes
                };
                createAnalyticsEvent({
                    eventType: kind,
                    ...body,
                    attributes: eventWithSubcontextAttributes
                }).fire($f89d3a6c9232b957$var$ANALYTICS_CHANNEL);
            });
        };
    return {
        fireOperationalEvent: fireEvent('operational'),
        fireScreenEvent: fireEvent('screen'),
        fireTrackEvent: fireEvent('track'),
        fireUIEvent: fireEvent('ui')
    };
};
var $f89d3a6c9232b957$export$30c16f5c43437fd7 = /*#__PURE__*/ function(AnalyticsAction) {
    AnalyticsAction["RENDERED"] = "rendered";
    AnalyticsAction["CLICKED"] = "clicked";
    AnalyticsAction["FAILED"] = "failed";
    AnalyticsAction["SUCCEEDED"] = "succeeded";
    AnalyticsAction["VIEWED"] = "viewed";
    AnalyticsAction["CLOSED"] = "closed";
    AnalyticsAction["ERROR"] = "error";
    AnalyticsAction["SUBMITED"] = "submitted";
    AnalyticsAction["FETCHED"] = "fetched";
    AnalyticsAction["SENT"] = "sent";
    AnalyticsAction["OPENED"] = "opened";
    return AnalyticsAction;
}({});

});

parcelRegister("cK1S8", function(module, exports) {

$parcel$export(module.exports, "transformPermissions", () => $0e8298b04935fd86$export$7fe0bfa353103198);
$parcel$export(module.exports, "getProductPermissionRequestBody", () => $0e8298b04935fd86$export$e16fe80afd1ad74c);
$parcel$export(module.exports, "hasProductPermission", () => $0e8298b04935fd86$export$a2eea90ce05a9f1c);

var $aByq2 = parcelRequire("aByq2");
const $0e8298b04935fd86$var$PRODUCTS = [
    'confluence',
    'jira',
    'jira-core',
    'jira-software',
    'jira-servicedesk',
    'jira-product-discovery',
    'loom'
];
const $0e8298b04935fd86$export$7fe0bfa353103198 = (permissions)=>{
    return permissions.reduce((acc, permission)=>{
        (0, $aByq2.SUPPORTED_PRODUCTS).forEach((supportedProduct)=>{
            if (permission.resourceId.includes(supportedProduct)) acc[supportedProduct] = {
                ...acc[supportedProduct],
                [permission.permissionId]: acc[supportedProduct]?.[permission.permissionId] || permission.permitted
            };
        });
        return acc;
    }, {});
};
const $0e8298b04935fd86$export$e16fe80afd1ad74c = (cloudId, userId, permissionIds)=>{
    const body = permissionIds.reduce((acc, permissionId)=>{
        const permission = {
            permissionId: permissionId,
            resourceId: '',
            principalId: `ari:cloud:identity::user/${userId}`,
            dontRequirePrincipalInSite: true
        };
        $0e8298b04935fd86$var$PRODUCTS.forEach((product)=>{
            acc.push({
                ...permission,
                resourceId: `ari:cloud:${product}::site/${cloudId}`
            });
        });
        return acc;
    }, []);
    return JSON.stringify(body);
};
const $0e8298b04935fd86$export$a2eea90ce05a9f1c = (permissions, product, permissionIds)=>{
    if (!permissions[product]) return false;
    if ((!permissionIds || permissionIds.length === 0) && permissions[product]) return Object.values(permissions[product] || {}).some((value)=>value === true);
    return permissionIds?.some((permissionId)=>permissions[product]?.[permissionId]);
};

});
parcelRegister("aByq2", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_PRODUCTS", () => $dfa26afbcfbb5a27$export$69caceff42c0da80);
const $dfa26afbcfbb5a27$export$69caceff42c0da80 = [
    'confluence',
    'jira',
    'loom'
];

});


parcelRegister("g1rvx", function(module, exports) {

$parcel$export(module.exports, "useProductPermissions", () => $c62cb3f798a3455e$export$5814f9544ee53f3b);

var $gwFzn = parcelRequire("gwFzn");

var $kN8Qy = parcelRequire("kN8Qy");
const $c62cb3f798a3455e$export$5814f9544ee53f3b = ({ userId: userId, cloudId: cloudId, permissionIds: permissionIds }, { enabled: enabled } = {
    enabled: true
})=>{
    const [state, { getPermissions: getPermissions }] = (0, $kN8Qy.useProductPermissionsStore)();
    const fetchData = (0, $gwFzn.useCallback)(async ()=>{
        getPermissions({
            cloudId: cloudId,
            userId: userId,
            enabled: enabled,
            permissionIds: permissionIds || [
                'manage',
                'write'
            ]
        });
    }, [
        cloudId,
        enabled,
        getPermissions,
        userId,
        permissionIds
    ]);
    (0, $gwFzn.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    return {
        loading: state.isLoading,
        data: state.permissions,
        error: state.error
    };
};

});
parcelRegister("kN8Qy", function(module, exports) {

$parcel$export(module.exports, "useProductPermissionsStore", () => $3124300e7fe6b906$export$933ed92af1ed5de9);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $cK1S8 = parcelRequire("cK1S8");
const $3124300e7fe6b906$var$actions = {
    getPermissions: ({ userId: userId, cloudId: cloudId, enabled: enabled, permissionIds: permissionIds = [
        'manage',
        'write'
    ] })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            const { hasLoaded: hasLoaded, isLoading: isLoading, permissions: permissions } = getState();
            if (isLoading || !userId || !cloudId || !enabled) return;
            const shouldFetch = !hasLoaded || permissionIds.some((permissionId)=>permissions.confluence?.[permissionId] === undefined || permissions.jira?.[permissionId] === undefined || permissions.loom?.[permissionId] === undefined);
            if (!shouldFetch) return;
            try {
                setState({
                    isLoading: true
                });
                const response = await fetch('/gateway/api/permissions/bulk/permitted', {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    method: 'POST',
                    credentials: 'include',
                    body: (0, $cK1S8.getProductPermissionRequestBody)(cloudId, userId, permissionIds)
                });
                if (!response.ok) throw new Error('Failed to fetch product permissions');
                const permissions = await response.json();
                dispatch($3124300e7fe6b906$var$actions.setPermissions(permissions));
            } catch (error) {
                dispatch($3124300e7fe6b906$var$actions.setError(new Error('Failed to fetch product permissions')));
            }
        },
    setError: (error)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                error: error
            });
        },
    setLoading: (isLoading)=>({ setState: setState })=>{
            setState({
                isLoading: isLoading
            });
        },
    setPermissions: (permissions)=>({ setState: setState })=>{
            setState({
                hasLoaded: true,
                isLoading: false,
                permissions: (0, $cK1S8.transformPermissions)(permissions),
                permissionsResponse: permissions
            });
        }
};
const $3124300e7fe6b906$var$Store = (0, $4ZoIm.createStore)({
    initialState: {
        error: undefined,
        hasLoaded: false,
        isLoading: false,
        permissions: {}
    },
    actions: $3124300e7fe6b906$var$actions,
    name: 'product-permissions'
});
const $3124300e7fe6b906$export$933ed92af1ed5de9 = (0, $iFWZA.createHook)($3124300e7fe6b906$var$Store);

});


parcelRegister("hogmh", function(module, exports) {

$parcel$export(module.exports, "useTeamContainersHook", () => $f181d773681f14f5$export$cdd1842df65e002f);
$parcel$export(module.exports, "useTeamContainers", () => $f181d773681f14f5$export$63f31a5bbbef2f9a);
$parcel$export(module.exports, "useConnectedTeams", () => $f181d773681f14f5$export$aadc628af3b5ef88);

var $gwFzn = parcelRequire("gwFzn");

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $inPa6 = parcelRequire("inPa6");

var $hbp6S = parcelRequire("hbp6S");

var $33hpz = parcelRequire("33hpz");
const $f181d773681f14f5$var$initialConnectedTeamsState = {
    containerId: undefined,
    isLoading: false,
    hasLoaded: false,
    teams: undefined,
    error: null,
    numberOfTeams: undefined
};
const $f181d773681f14f5$var$initialState = {
    teamContainers: [],
    loading: true,
    hasLoaded: false,
    error: null,
    unlinkError: null,
    teamId: null,
    connectedTeams: $f181d773681f14f5$var$initialConnectedTeamsState
};
const $f181d773681f14f5$var$actions = {
    fetchTeamContainers: (teamId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { teamId: currentTeamId } = getState();
            if (currentTeamId === teamId) return;
            setState({
                loading: true,
                error: null,
                teamContainers: [],
                teamId: teamId,
                hasLoaded: false
            });
            try {
                const containers = await (0, $33hpz.teamsClient).getTeamContainers(teamId);
                fireAnalytics((0, $hbp6S.AnalyticsAction).SUCCEEDED, 'fetchTeamContainers');
                setState({
                    teamContainers: containers,
                    loading: false,
                    error: null,
                    hasLoaded: true
                });
            } catch (err) {
                fireAnalytics((0, $hbp6S.AnalyticsAction).FAILED, 'fetchTeamContainers', err);
                setState({
                    teamContainers: [],
                    error: err,
                    loading: false,
                    hasLoaded: true
                });
            }
        },
    fetchNumberOfConnectedTeams: (containerId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId } } = getState();
            if (currentContainerId === containerId) return;
            setState({
                connectedTeams: {
                    ...$f181d773681f14f5$var$initialConnectedTeamsState,
                    containerId: containerId,
                    numberOfTeams: undefined
                }
            });
            try {
                const numberOfTeams = await (0, $33hpz.teamsClient).getNumberOfConnectedTeams(containerId);
                fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        ...$f181d773681f14f5$var$initialConnectedTeamsState,
                        containerId: containerId,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).FAILED,
                    actionSubject: 'fetchNumberOfConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: $f181d773681f14f5$var$initialConnectedTeamsState.numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        ...$f181d773681f14f5$var$initialConnectedTeamsState,
                        containerId: containerId,
                        error: e
                    }
                });
            }
        },
    fetchConnectedTeams: (containerId, fireAnalytics)=>async ({ setState: setState, getState: getState })=>{
            const { connectedTeams: { containerId: currentContainerId, numberOfTeams: numberOfTeams, hasLoaded: hasLoaded } } = getState();
            if (currentContainerId === containerId && hasLoaded) return;
            setState({
                connectedTeams: {
                    containerId: containerId,
                    isLoading: true,
                    hasLoaded: false,
                    teams: undefined,
                    error: null,
                    numberOfTeams: numberOfTeams
                }
            });
            try {
                const teams = await (0, $33hpz.teamsClient).getConnectedTeams(containerId);
                fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).SUCCEEDED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: true,
                        teams: teams,
                        error: null,
                        numberOfTeams: numberOfTeams
                    }
                });
            } catch (e) {
                fireAnalytics({
                    action: (0, $hbp6S.AnalyticsAction).FAILED,
                    actionSubject: 'fetchConnectedTeams',
                    containerId: containerId,
                    numberOfTeams: numberOfTeams,
                    error: e
                });
                setState({
                    connectedTeams: {
                        containerId: containerId,
                        isLoading: false,
                        hasLoaded: false,
                        teams: [],
                        error: e,
                        numberOfTeams: numberOfTeams
                    }
                });
            }
        },
    unlinkTeamContainers: (teamId, containerId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                unlinkError: null
            });
            try {
                const mutationResult = await (0, $33hpz.teamsClient).unlinkTeamContainer(teamId, containerId);
                if (mutationResult.deleteTeamConnectedToContainer.errors.length) // Just handle 1 error at a time should be suffcient as we disconenct only 1 container at a time
                setState({
                    unlinkError: mutationResult.deleteTeamConnectedToContainer.errors[0]
                });
                else {
                    const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
                    const newContainers = teamContainers.filter((container)=>container.id !== containerId);
                    if (connectedTeams.containerId === containerId) setState({
                        teamContainers: newContainers,
                        connectedTeams: $f181d773681f14f5$var$initialConnectedTeamsState
                    });
                    else setState({
                        teamContainers: newContainers
                    });
                }
            } catch (err) {
                setState({
                    unlinkError: err
                });
            }
        },
    addTeamContainer: (teamContainer)=>async ({ setState: setState, getState: getState })=>{
            const { teamContainers: teamContainers, connectedTeams: connectedTeams } = getState();
            const containerExists = teamContainers.some((container)=>container.id === teamContainer.id);
            if (containerExists) return;
            if (connectedTeams.containerId === teamContainer.id) setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ],
                connectedTeams: $f181d773681f14f5$var$initialConnectedTeamsState
            });
            else setState({
                teamContainers: [
                    ...teamContainers,
                    teamContainer
                ]
            });
        }
};
const $f181d773681f14f5$var$Store = (0, $4ZoIm.createStore)({
    initialState: $f181d773681f14f5$var$initialState,
    actions: $f181d773681f14f5$var$actions,
    name: 'teamContainersStore'
});
const $f181d773681f14f5$export$cdd1842df65e002f = (0, $iFWZA.createHook)($f181d773681f14f5$var$Store);
const $f181d773681f14f5$export$63f31a5bbbef2f9a = (teamId, enable = true)=>{
    const [state, actions] = $f181d773681f14f5$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $gwFzn.useCallback)((action, actionSubject, error)=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                teamId: teamId,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent,
        teamId
    ]);
    (0, $gwFzn.useEffect)(()=>{
        if (enable) actions.fetchTeamContainers(teamId, fireOperationalAnalytics);
    }, [
        teamId,
        actions,
        enable,
        fireOperationalAnalytics
    ]);
    return {
        ...state,
        addTeamContainer: actions.addTeamContainer,
        unlinkTeamContainers: (containerId)=>actions.unlinkTeamContainers(teamId, containerId)
    };
};
const $f181d773681f14f5$export$aadc628af3b5ef88 = ()=>{
    const [state, actions] = $f181d773681f14f5$export$cdd1842df65e002f();
    const { fireOperationalEvent: fireOperationalEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireOperationalAnalytics = (0, $gwFzn.useCallback)(({ action: action, actionSubject: actionSubject, containerId: containerId, numberOfTeams: numberOfTeams, error: error })=>{
        fireOperationalEvent(createAnalyticsEvent, {
            action: action,
            actionSubject: actionSubject,
            attributes: {
                containerId: containerId,
                numberOfTeams: numberOfTeams,
                ...error && {
                    error: {
                        message: error.message || JSON.stringify(error),
                        stack: error.stack
                    }
                }
            }
        });
    }, [
        fireOperationalEvent,
        createAnalyticsEvent
    ]);
    return {
        ...state.connectedTeams,
        fetchNumberOfConnectedTeams: (containerId)=>actions.fetchNumberOfConnectedTeams(containerId, fireOperationalAnalytics),
        fetchConnectedTeams: (containerId)=>actions.fetchConnectedTeams(containerId, fireOperationalAnalytics)
    };
};

});
parcelRegister("33hpz", function(module, exports) {

$parcel$export(module.exports, "teamsClient", () => $a3e448e892f0059a$export$5ed932c3646b89c6);

var $4UCbU = parcelRequire("4UCbU");
class $a3e448e892f0059a$export$db59823f35bf78ce {
    /**
   * Sets the base URL to be used in the client requests
   * @param {string} baseUrl - The new base URL
   */ setBaseUrl(baseUrl) {
        this._aggClient.setBaseUrl(baseUrl);
    }
    /**
   * Sets context including CloudId & OrgId to be used for all requests
   */ setContext(context) {
        this._aggClient.setContext(context);
    }
    /**
   * Get the containers for a given team
   * @param {string} teamId
   * @returns {Promise<TeamContainers>}
   */ async getTeamContainers(teamId) {
        return this._aggClient.getTeamContainers(teamId);
    }
    /**
   * Get the number of teams connected to a container (Confluence space or Jira project)
   * @param {string} containerId
   * @returns {Promise}
   */ async getNumberOfConnectedTeams(containerId) {
        return this._aggClient.queryNumberOfTeamConnectedToContainer(containerId);
    }
    /**
   * Get teams connected to a container (Confluence space or Jira project)
   * @param {string} containerId
   * @returns {Promise}
   */ async getConnectedTeams(containerId) {
        return this._aggClient.queryTeamsConnectedToContainer(containerId);
    }
    /**
   * Unlink a container from a team
   * @param {string} teamId
   * @param {string} containerId
   * @returns {Promise<void>}
   */ async unlinkTeamContainer(teamId, containerId) {
        return this._aggClient.unlinkTeamContainer(teamId, containerId);
    }
    constructor(/**
   * @param {ClientContextProps} context - Context including CloudId & OrgId to be used for all requests
   */ context){
        this._aggClient = (0, $4UCbU.aggClient);
        if (context) this.setContext(context);
    }
}
const $a3e448e892f0059a$export$5ed932c3646b89c6 = new $a3e448e892f0059a$export$db59823f35bf78ce();

});
parcelRegister("4UCbU", function(module, exports) {

$parcel$export(module.exports, "aggClient", () => $5f24f938450d67eb$export$464c991dbf0b2393);

var $5njCw = parcelRequire("5njCw");

var $cmPay = parcelRequire("cmPay");

var $dD8NW = parcelRequire("dD8NW");

var $2GdQj = parcelRequire("2GdQj");

var $lN1uy = parcelRequire("lN1uy");

var $963s4 = parcelRequire("963s4");

var $5VJDa = parcelRequire("5VJDa");

var $5UwGb = parcelRequire("5UwGb");
class $5f24f938450d67eb$export$b44e5dafe13af7b3 extends (0, $2GdQj.BaseGraphQlClient) {
    setBaseUrl(baseUrl) {
        this.setServiceUrl(`${baseUrl}/graphql`);
    }
    async getTeamContainers(teamId) {
        const teamAri = (0, $5njCw.teamIdToAri)(teamId);
        const cypherQuery = `MATCH (team:IdentityTeam {ari: '${teamAri}'})-[:team_connected_to_container]->(container) RETURN container`;
        const response = await this.makeGraphQLRequest({
            query: (0, $5UwGb.TeamContainersQuery),
            variables: {
                cypherQuery: cypherQuery
            }
        }, {
            operationName: 'TeamContainersQuery'
        });
        const containersResult = response.graphStore.cypherQuery.edges.reduce((containers, edge)=>{
            if (edge.node.to.data.__typename === 'ConfluenceSpace') containers.push({
                id: edge.node.to.id,
                type: edge.node.to.data.__typename,
                name: edge.node.to.data.confluenceSpaceName || '',
                icon: `${edge.node.to.data.links.base}${edge.node.to.data.icon.path}`,
                createdDate: new Date(edge.node.to.data.createdDate),
                link: `${edge.node.to.data.links.base}${edge.node.to.data.links.webUi}`,
                containerTypeProperties: {
                    subType: undefined,
                    name: undefined
                }
            });
            else if (edge.node.to.data.__typename === 'JiraProject') containers.push({
                id: edge.node.to.id,
                type: edge.node.to.data.__typename,
                name: edge.node.to.data.jiraProjectName,
                icon: edge.node.to.data.avatar.medium,
                createdDate: new Date(edge.node.to.data.created),
                link: edge.node.to.data.webUrl,
                containerTypeProperties: {
                    subType: edge.node.to.data.projectType || '',
                    name: edge.node.to.data.projectTypeName || ''
                }
            });
            else if (edge.node.to.data.__typename === 'LoomSpace') containers.push({
                id: edge.node.to.id,
                type: edge.node.to.data.__typename,
                name: edge.node.to.data.loomSpaceName,
                icon: '',
                link: edge.node.to.data.url
            });
            return containers;
        }, []);
        return containersResult;
    }
    async unlinkTeamContainer(teamId, containerId) {
        const teamAri = (0, $5njCw.teamIdToAri)(teamId);
        const response = await this.makeGraphQLRequest({
            query: (0, $lN1uy.UnlinkContainerMutation),
            variables: {
                containerId: containerId,
                teamId: teamAri
            }
        }, {
            operationName: 'UnlinkContainerMutation'
        });
        return response.graphStore;
    }
    async queryNumberOfTeamConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $963s4.NumberOfTeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'NumberOfTeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.length;
    }
    async queryTeamsConnectedToContainer(containerId) {
        const response = await this.makeGraphQLRequest({
            query: (0, $5VJDa.TeamConnectedToContainerQuery),
            variables: {
                containerId: containerId
            }
        }, {
            operationName: 'TeamConnectedToContainerQuery'
        });
        return response?.graphStore?.teamConnectedToContainerInverse?.edges?.map(({ node: node })=>({
                id: node.id,
                displayName: node.displayName,
                description: node.description,
                state: node.state,
                membershipSettings: node.membershipSettings,
                organizationId: node.organizationId,
                creatorId: node.creator?.id,
                isVerified: node.isVerified,
                members: node.members?.nodes.map(({ member: member })=>({
                        id: member?.id ? (0, $cmPay.toUserId)(member?.id) : '',
                        fullName: member?.name ?? '',
                        avatarUrl: member?.picture,
                        status: member?.accountStatus
                    })) ?? [],
                includesYou: false,
                // to-do - this needs to be computed - https://product-fabric.atlassian.net/browse/CCECO-4368
                memberCount: node.members?.nodes.length ?? 0,
                largeAvatarImageUrl: node.largeAvatarImageUrl,
                smallAvatarImageUrl: node.smallAvatarImageUrl,
                largeHeaderImageUrl: node.largeHeaderImageUrl,
                smallHeaderImageUrl: node.smallHeaderImageUrl,
                restriction: 'ORG_MEMBERS' // to-do - figure out if this should be optional (it's deprecated) - https://product-fabric.atlassian.net/browse/CCECO-4368
            }));
    }
    constructor(baseUrl, config){
        super(`${baseUrl}/graphql`, config);
    }
}
const $5f24f938450d67eb$export$464c991dbf0b2393 = new $5f24f938450d67eb$export$b44e5dafe13af7b3((0, $dD8NW.DEFAULT_CONFIG).stargateRoot, {
    logException: ()=>{}
});

});
parcelRegister("5njCw", function(module, exports) {

$parcel$export(module.exports, "teamIdToAri", () => $e3600f39ca041e80$export$dd2be0859897f01f);
const $e3600f39ca041e80$export$e33271562ca4c847 = 'ari:cloud:identity::team/';
const $e3600f39ca041e80$export$dd2be0859897f01f = (teamIdOrTeamAri)=>teamIdOrTeamAri.startsWith($e3600f39ca041e80$export$e33271562ca4c847) ? teamIdOrTeamAri : `${$e3600f39ca041e80$export$e33271562ca4c847}${teamIdOrTeamAri}`;

});

parcelRegister("cmPay", function(module, exports) {

$parcel$export(module.exports, "toUserId", () => $b55bb688c63a8bdb$export$1d0eef1d33b05366);

var $cK9bZ = parcelRequire("cK9bZ");
const $b55bb688c63a8bdb$export$caac29844ad91f64 = (ari)=>ari.startsWith((0, $cK9bZ.USER_ARI_PREFIX));
const $b55bb688c63a8bdb$export$1d0eef1d33b05366 = (ari)=>{
    if ($b55bb688c63a8bdb$export$caac29844ad91f64(ari)) return ari.replace((0, $cK9bZ.USER_ARI_PREFIX), '');
    throw new Error('Invalid UserARI');
};

});
parcelRegister("cK9bZ", function(module, exports) {

$parcel$export(module.exports, "USER_ARI_PREFIX", () => $9ded6b780cfd14f4$export$470b0d72e4fdc43a);
var $9ded6b780cfd14f4$export$be86baa40543cfe6 = /*#__PURE__*/ function(JiraProjectTypes) {
    JiraProjectTypes["PRODUCT_DISCOVERY"] = "Product Discovery";
    JiraProjectTypes["SOFTWARE"] = "Software";
    JiraProjectTypes["SERVICE_DESK"] = "Service Desk";
    JiraProjectTypes["BUSINESS"] = "Business";
    JiraProjectTypes["CUSTOMER_SERVICE"] = "Customer Service";
    return JiraProjectTypes;
}({});
const $9ded6b780cfd14f4$export$470b0d72e4fdc43a = 'ari:cloud:identity::user/';
const $9ded6b780cfd14f4$export$cfedc369802e0c68 = 'ari:cloud:identity::team/';

});


parcelRegister("dD8NW", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CONFIG", () => $4bda0bdcab523f81$export$c2f8e0cc249a8d8f);
const $4bda0bdcab523f81$export$c2f8e0cc249a8d8f = {
    stargateRoot: '/gateway/api'
};

});

parcelRegister("2GdQj", function(module, exports) {

$parcel$export(module.exports, "BaseGraphQlClient", () => $6273787f81635f1c$export$42f6d6baced34b2d);

var $iAw0s = parcelRequire("iAw0s");

var $hCXHo = parcelRequire("hCXHo");

var $4cKP4 = parcelRequire("4cKP4");
class $6273787f81635f1c$export$42f6d6baced34b2d extends (0, $hCXHo.BaseClient) {
    setServiceUrl(serviceUrl) {
        this.serviceUrl = serviceUrl;
    }
    async makeGraphQLRequest(body, options = {}) {
        try {
            return (0, $4cKP4.handleGraphQLRequest)(this.serviceUrl, body, options);
        } catch (error) {
            if (error instanceof (0, $iAw0s.GraphQLError)) throw error;
            this.logException(error, 'UnknownError in GraphQLClient.makeGraphQLRequestWithoutRetries');
            throw new (0, $iAw0s.DefaultError)({});
        }
    }
    constructor(serviceUrl, config){
        super(config);
        this.serviceUrl = void 0;
        this.serviceUrl = serviceUrl;
    }
}

});
parcelRegister("iAw0s", function(module, exports) {

$parcel$export(module.exports, "DefaultError", () => $79f3c719c35ec747$export$c73ca302efeda3b4);
$parcel$export(module.exports, "HttpError", () => $79f3c719c35ec747$export$65bd6083489bd8bb);
$parcel$export(module.exports, "GraphQLError", () => $79f3c719c35ec747$export$92d6ed0888e7cb7f);
var $79f3c719c35ec747$var$_GraphQLError;
var $79f3c719c35ec747$export$f66f92b8741acd5b = /*#__PURE__*/ function(StatusCode) {
    StatusCode[StatusCode["UNAUTHORIZED"] = 401] = "UNAUTHORIZED";
    StatusCode[StatusCode["FORBIDDEN"] = 403] = "FORBIDDEN";
    StatusCode[StatusCode["TIMEOUT"] = 408] = "TIMEOUT";
    StatusCode[StatusCode["GONE"] = 410] = "GONE";
    StatusCode[StatusCode["PAYLOAD_TOO_LARGE"] = 413] = "PAYLOAD_TOO_LARGE";
    return StatusCode;
}({});
class $79f3c719c35ec747$var$CommonError extends Error {
    constructor(message){
        super(message);
        this.message = void 0;
        this.name = void 0;
        this.stack = void 0;
        this.name = this.constructor.name;
        this.message = message || 'UnknownError';
        this.stack = new Error(message).stack || '';
    }
}
class $79f3c719c35ec747$export$c73ca302efeda3b4 extends $79f3c719c35ec747$var$CommonError {
    constructor({ message: message }){
        super(message || 'UnknownError');
        Object.setPrototypeOf(this, $79f3c719c35ec747$export$c73ca302efeda3b4.prototype);
    }
}
class $79f3c719c35ec747$export$d87f401f8106d7a2 extends $79f3c719c35ec747$var$CommonError {
    constructor({ message: message }){
        super(`SentryIgnore: ${message || 'UnknownError'}`);
        Object.setPrototypeOf(this, $79f3c719c35ec747$export$d87f401f8106d7a2.prototype);
    }
}
class $79f3c719c35ec747$export$65bd6083489bd8bb extends $79f3c719c35ec747$var$CommonError {
    constructor({ message: message, status: status, traceId: traceId, path: path }){
        super(message);
        this.status = void 0;
        this.traceId = void 0;
        this.path = void 0;
        Object.setPrototypeOf(this, $79f3c719c35ec747$export$65bd6083489bd8bb.prototype);
        this.status = status;
        this.traceId = traceId;
        this.path = path;
    }
}
class $79f3c719c35ec747$export$92d6ed0888e7cb7f extends $79f3c719c35ec747$var$CommonError {
    constructor({ message: message, category: category = 'default', fields: fields }){
        super(message);
        this.fields = void 0;
        // tslint:disable-line no-any
        this.category = void 0;
        Object.setPrototypeOf(this, $79f3c719c35ec747$export$92d6ed0888e7cb7f.prototype);
        this.category = category;
        if (fields) this.fields = fields;
    }
}
$79f3c719c35ec747$var$_GraphQLError = $79f3c719c35ec747$export$92d6ed0888e7cb7f;
$79f3c719c35ec747$export$92d6ed0888e7cb7f.from = (rawErrors)=>{
    const firstError = rawErrors[0];
    const errorData = {
        category: firstError.category,
        message: firstError.message
    };
    if (firstError.fields) errorData.fields = firstError.fields.reduce((obj, item)=>{
        obj[item.field] = item.message;
        return obj;
    }, {});
    return new $79f3c719c35ec747$var$_GraphQLError(errorData);
};

});

parcelRegister("hCXHo", function(module, exports) {

$parcel$export(module.exports, "BaseClient", () => $1901bb3c4161f935$export$4f22f74eddb7716a);
class $1901bb3c4161f935$export$4f22f74eddb7716a {
    setContext(context) {
        this.context = {
            ...context,
            cloudId: context.cloudId || null
        };
    }
    getContext() {
        return this.context;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getOrgId(localValue) {
        const orgId = localValue || this.getContext().orgId;
        if (!orgId) {
            const err = new Error('No orgId set');
            this.logException(err, 'No orgId set');
            throw err;
        }
        return orgId;
    }
    /**
   *
   * @param localValue is used for backwards compatibility
   * @returns
   */ getCloudId(localValue) {
        return localValue || this.getContext().cloudId;
    }
    keyWithContext(key) {
        return `${this.getContext().cloudId}-${this.getContext().orgId ?? 'no-org-id'}-${this.getContext().userId ?? 'no-user-id'}-${key}`;
    }
    // Default expiration is 5 minutes
    cacheValue(key, value, expiryMs = 300000) {
        this.cache[this.keyWithContext(key)] = {
            data: value,
            expiration: Date.now() + expiryMs
        };
    }
    getCachedValue(key) {
        const record = this.cache[this.keyWithContext(key)];
        if (record && record.expiration > Date.now()) return record.data;
        return undefined;
    }
    constructor(config){
        this.config = void 0;
        this.context = void 0;
        this.cache = {};
        this.logException = (ex, name, context)=>{
            this.config.logException(ex, name, context);
        };
        this.config = config;
        this.context = {
            cloudId: null
        };
    }
}

});

parcelRegister("4cKP4", function(module, exports) {

$parcel$export(module.exports, "handleGraphQLRequest", () => $80061c5d2bfc5bdf$export$7feffc86760ee7ce);

var $iAw0s = parcelRequire("iAw0s");

var $4cX0x = parcelRequire("4cX0x");

var $gL302 = parcelRequire("gL302");
async function $80061c5d2bfc5bdf$export$93d33e3b46bf00e7(serviceUrl, body, options = {}) {
    const operationNameQuery = options.operationName ? `?q=${options.operationName}` : '';
    const errorPolicy = options.errorPolicy || 'none';
    const url = serviceUrl + operationNameQuery;
    const request = fetch(url, {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        credentials: 'include',
        body: JSON.stringify(body)
    }).then((res)=>{
        if (res.status < 300 || res.status === 400) return res.json();
        else throw res;
    });
    try {
        const response = await request;
        const errors = response.errors;
        if (errors) {
            if (errorPolicy === 'none') throw (0, $iAw0s.GraphQLError).from(errors);
            else if (errorPolicy === 'all') // Set timeout will postpone error throwing and de-touch it to another event loop,
            // so we can return data along with throwing error
            return new Promise((resolve, reject)=>{
                setTimeout(()=>{
                    reject((0, $iAw0s.GraphQLError).from(errors));
                }, 0);
            });
        }
        return response.data;
    } catch (error) {
        if (error instanceof Response) return {
            response: error
        };
        if (Object(error).hasOwnProperty('response')) throw error;
        return error;
    }
}
async function $80061c5d2bfc5bdf$export$7feffc86760ee7ce(serviceUrl, body, options = {}) {
    const makeGraphQLRequestWithRetries = (0, $4cX0x.withExponentialBackoff)($80061c5d2bfc5bdf$export$93d33e3b46bf00e7, {
        initial: (0, $4cX0x.EXPONENTIAL_BACKOFF_RETRY_POLICY).INITIAL_DELAY,
        jitter: (0, $4cX0x.EXPONENTIAL_BACKOFF_RETRY_POLICY).JITTER,
        max: (0, $4cX0x.EXPONENTIAL_BACKOFF_RETRY_POLICY).MAX_RETRIES,
        retryIf: (data)=>{
            return (0, $4cX0x.isFetchResponse)(data) && (0, $4cX0x.is5xx)(data.response.status);
        }
    });
    const result = await makeGraphQLRequestWithRetries(serviceUrl, body, options);
    const response = result?.response;
    if (response) {
        const status = response.status;
        const statusText = response.statusText;
        const traceId = response.headers.get('atl-traceid');
        (0, $gL302.handleResponse)(response);
        if (status > 400 && status <= 599) throw new (0, $iAw0s.HttpError)({
            message: statusText,
            status: status,
            traceId: traceId ?? undefined
        });
    }
    return result;
}

});
parcelRegister("4cX0x", function(module, exports) {

$parcel$export(module.exports, "EXPONENTIAL_BACKOFF_RETRY_POLICY", () => $961e38fa5ad1e575$export$8f4286bf21155381);
$parcel$export(module.exports, "is5xx", () => $961e38fa5ad1e575$export$55b2fbd5d4a32495);
$parcel$export(module.exports, "isFetchResponse", () => $961e38fa5ad1e575$export$81f27058be86d7ea);
$parcel$export(module.exports, "withExponentialBackoff", () => $961e38fa5ad1e575$export$20eaa22f2295996f);
const $961e38fa5ad1e575$export$8f4286bf21155381 = {
    INITIAL_DELAY: 200,
    MAX_RETRIES: 5,
    JITTER: true
};
function $961e38fa5ad1e575$export$55b2fbd5d4a32495(status) {
    return 500 <= status && status <= 599;
}
function $961e38fa5ad1e575$export$81f27058be86d7ea(data) {
    if (!data || !data.hasOwnProperty('response')) return false;
    return data.response instanceof Response;
}
// tslint:disable-next-line no-any
const $961e38fa5ad1e575$var$defaultRetryIfCallback = (a)=>!a;
const $961e38fa5ad1e575$var$defaultOptions = {
    initial: 200,
    jitter: false,
    max: 5,
    retryIf: $961e38fa5ad1e575$var$defaultRetryIfCallback
};
function $961e38fa5ad1e575$export$20eaa22f2295996f(toTry, hofOptions = $961e38fa5ad1e575$var$defaultOptions) {
    const { initial: initial, jitter: jitter, max: max, retryIf: retryIf } = hofOptions;
    // Initialize max retry decrementing counter (range of max...0)
    let attemptsRemaining = max;
    // Initialize delay. This will exponentially increase each retry (delay = intial * 2^n)
    let delay = initial;
    /**
	 * This function calls itself recursively until `retryIf` evaluates false or the retry limit is reached.
	 * The functioned-to-be-retried is called on each recursion.
	 */ return async function tryWithExponentialBackoff(...args) {
        // "An attempt was made"
        const result = await toTry(...args);
        --attemptsRemaining;
        // If tried function was unsuccessful and there are still retries remaining, retry!
        if (retryIf && retryIf(result) && attemptsRemaining > 0) {
            // Wait for delay
            await new Promise((resolve)=>setTimeout(resolve, jitter ? Math.random() * delay : delay));
            // Exponentially increase delay
            delay *= 2;
            // Initiate retry
            return tryWithExponentialBackoff(...args);
        }
        // Return result of tried function if it is successful or if the retry limit
        // was reached regardless of success.
        return result;
    };
}
const $961e38fa5ad1e575$export$b4c0bf5325504bf3 = $961e38fa5ad1e575$export$20eaa22f2295996f((url, init)=>fetch(url, init), {
    initial: $961e38fa5ad1e575$export$8f4286bf21155381.INITIAL_DELAY,
    jitter: $961e38fa5ad1e575$export$8f4286bf21155381.JITTER,
    max: $961e38fa5ad1e575$export$8f4286bf21155381.MAX_RETRIES,
    retryIf: (response)=>$961e38fa5ad1e575$export$55b2fbd5d4a32495(response.status)
});

});

parcelRegister("gL302", function(module, exports) {

$parcel$export(module.exports, "handleResponse", () => $e70aa1b3665fe293$export$c113a67a6762ad2e);
/**
 * Our REST clients are initialised when their module loads which makes it tricky for them to consume the `statusCodeHandlers` prop passed to App from the host application.
 * This is a temporary measure to enable the clients to consume `statusCodeHandlers`.
 * The long term solution is to replace our REST clients with Apollo client custom resolvers
 * This will unify all remote data handling under the apollo-client module which is able to easily receive `statusCodeHandlers` as it is initialised within the React portion of our app.
 */ const $e70aa1b3665fe293$export$8c005e458e12d501 = {
    handlers: {},
    get () {
        return $e70aa1b3665fe293$export$8c005e458e12d501.handlers;
    },
    setHandlers (handlers) {
        $e70aa1b3665fe293$export$8c005e458e12d501.handlers = handlers;
    }
};
function $e70aa1b3665fe293$export$c113a67a6762ad2e(response) {
    const { status: status } = response;
    const handler = $e70aa1b3665fe293$export$8c005e458e12d501.get()[status];
    if (typeof handler === 'function') handler(response);
}

});



parcelRegister("lN1uy", function(module, exports) {

$parcel$export(module.exports, "UnlinkContainerMutation", () => $f4964cf4ed2fbd49$export$74f3ccf149f124b);

var $aLaTe = parcelRequire("aLaTe");

var $d2LG0 = parcelRequire("d2LG0");
const $f4964cf4ed2fbd49$export$74f3ccf149f124b = (0, $aLaTe.print)((0, $d2LG0.default)`mutation unlinkTeamToContainerMutation($teamId:ID!$containerId:ID!){graphStore@optIn(to:["GraphStoreMutation"]){deleteTeamConnectedToContainer(input:{relationships:[{from:$teamId to:$containerId}]})@optIn(to:["GraphStoreTeamConnectedToContainer"]){errors{message extensions{statusCode errorType}}success}}}`);

});

parcelRegister("963s4", function(module, exports) {

$parcel$export(module.exports, "NumberOfTeamConnectedToContainerQuery", () => $812572cd49d7236a$export$6c9c309d551311e);

var $aLaTe = parcelRequire("aLaTe");

var $d2LG0 = parcelRequire("d2LG0");
const $812572cd49d7236a$export$6c9c309d551311e = (0, $aLaTe.print)((0, $d2LG0.default)`query getNumberOfTeamsForContainer($containerId:ID!){graphStore@optIn(to:"GraphStore"){teamConnectedToContainerInverse(id:$containerId consistentRead:true)@optIn(to:"GraphStoreTeamConnectedToContainer"){edges{id}}}}`);

});

parcelRegister("5VJDa", function(module, exports) {

$parcel$export(module.exports, "TeamConnectedToContainerQuery", () => $ad6d37ced9a37066$export$8e179b6008492526);

var $aLaTe = parcelRequire("aLaTe");

var $d2LG0 = parcelRequire("d2LG0");
const $ad6d37ced9a37066$export$8e179b6008492526 = (0, $aLaTe.print)((0, $d2LG0.default)`query getTeamsForContainer($containerId:ID!){graphStore@optIn(to:"GraphStore"){teamConnectedToContainerInverse(id:$containerId consistentRead:true)@optIn(to:"GraphStoreTeamConnectedToContainer"){edges{node{...on TeamV2{id description displayName creator{id}smallAvatarImageUrl smallHeaderImageUrl largeAvatarImageUrl largeHeaderImageUrl members{nodes{member{id name picture accountStatus ...on AtlassianAccountUser{extendedProfile{jobTitle}}...on AppUser{appType}}role state}pageInfo{endCursor hasNextPage}}organizationId membershipSettings isVerified state}}}}}}`);

});

parcelRegister("5UwGb", function(module, exports) {

$parcel$export(module.exports, "TeamContainersQuery", () => $e3513aedffd29532$export$f0275d326396e5f9);

var $aLaTe = parcelRequire("aLaTe");

var $d2LG0 = parcelRequire("d2LG0");
const $e3513aedffd29532$export$f0275d326396e5f9 = (0, $aLaTe.print)((0, $d2LG0.default)`query TeamContainersQuery($cypherQuery:String!){graphStore@optIn(to:["GraphStore"]){cypherQuery(query:$cypherQuery)@optIn(to:["GraphStoreCypherQuery"]){edges{__typename node{from{id}to{id data{__typename ...on ConfluenceSpace{id confluenceSpaceName:name type createdDate links{base webUi}icon{path}}...on JiraProject{id jiraProjectName:name webUrl created avatar{medium}projectType projectTypeName}...on LoomSpace{id loomSpaceName:name url}}}}}}}}`);

});




parcelRegister("aYWXT", function(module, exports) {

$parcel$export(module.exports, "useTeamLinksAndContainers", () => $18f36a201d3ef90d$export$5200d5ff4aebd4a7);

var $gwFzn = parcelRequire("gwFzn");

var $dJxWI = parcelRequire("dJxWI");

var $hogmh = parcelRequire("hogmh");

var $jUUM4 = parcelRequire("jUUM4");
const $18f36a201d3ef90d$var$MAX_LINKS_LIMIT = 10;
const $18f36a201d3ef90d$export$5200d5ff4aebd4a7 = (teamId, enableContainers = true)=>{
    const { teamContainers: teamContainers, loading: containersLoading, hasLoaded: containersHasLoaded, error: containersError, addTeamContainer: addTeamContainer, unlinkTeamContainers: unlinkTeamContainers } = (0, $hogmh.useTeamContainers)(teamId, enableContainers);
    const [{ links: links, isLoading: webLinksLoading, hasError: webLinksError, hasLoaded: webLinksHasLoaded }, { getTeamWebLinks: getTeamWebLinks, createTeamWebLink: createTeamWebLink, updateTeamWebLink: updateTeamWebLink, removeWebLink: removeWebLink }] = (0, $jUUM4.useTeamWebLinks)();
    (0, $gwFzn.useEffect)(()=>{
        getTeamWebLinks(teamId);
    }, [
        getTeamWebLinks,
        teamId
    ]);
    const webLinkContainers = (0, $gwFzn.useMemo)(()=>(0, $dJxWI.webLinksToContainers)(links), [
        links
    ]);
    const allContainers = (0, $gwFzn.useMemo)(()=>[
            ...teamContainers,
            ...webLinkContainers
        ], [
        teamContainers,
        webLinkContainers
    ]);
    const canAddMoreLink = (0, $gwFzn.useMemo)(()=>allContainers.length <= $18f36a201d3ef90d$var$MAX_LINKS_LIMIT, [
        allContainers.length
    ]);
    const addTeamLink = (0, $gwFzn.useCallback)(async (container)=>{
        if (container.type === 'WebLink') {
            const webLink = (0, $dJxWI.containerToNewWebLink)(container);
            return await createTeamWebLink(teamId, webLink);
        } else {
            addTeamContainer(container);
            return Promise.resolve(container);
        }
    }, [
        teamId,
        createTeamWebLink,
        addTeamContainer
    ]);
    const updateTeamLink = (0, $gwFzn.useCallback)(async (container, newContainer)=>{
        if (container.type === 'WebLink') {
            const webLink = (0, $dJxWI.containerToNewWebLink)(newContainer);
            return await updateTeamWebLink(teamId, container.id, webLink);
        }
    }, [
        teamId,
        updateTeamWebLink
    ]);
    const removeTeamLink = (0, $gwFzn.useCallback)(async (container)=>{
        if (container.type === 'WebLink') await removeWebLink(teamId, container.id);
        else await unlinkTeamContainers(container.id);
    }, [
        teamId,
        removeWebLink,
        unlinkTeamContainers
    ]);
    return {
        isLoading: containersLoading || webLinksLoading,
        hasError: !!containersError || webLinksError,
        containersError: !!containersError,
        webLinksError: webLinksError,
        containersHasLoaded: containersHasLoaded,
        webLinksHasLoaded: webLinksHasLoaded,
        hasLoaded: containersHasLoaded && webLinksHasLoaded,
        teamLinks: allContainers,
        canAddMoreLink: canAddMoreLink,
        addTeamLink: addTeamLink,
        updateTeamLink: updateTeamLink,
        removeTeamLink: removeTeamLink
    };
};

});
parcelRegister("dJxWI", function(module, exports) {

$parcel$export(module.exports, "containerToNewWebLink", () => $521399c659dfa8b9$export$7cd9d491ff28b738);
$parcel$export(module.exports, "webLinksToContainers", () => $521399c659dfa8b9$export$6a7bb6c7b84e9956);
const $521399c659dfa8b9$export$7cd9d491ff28b738 = (container)=>{
    return {
        contentTitle: container.name,
        description: '',
        linkUri: container.link || ''
    };
};
const $521399c659dfa8b9$export$34d06abc801403e2 = (link)=>{
    return {
        id: link.linkId,
        type: 'WebLink',
        name: link.contentTitle,
        icon: null,
        link: link.linkUri
    };
};
const $521399c659dfa8b9$export$6a7bb6c7b84e9956 = (links)=>{
    return links.map($521399c659dfa8b9$export$34d06abc801403e2);
};

});

parcelRegister("jUUM4", function(module, exports) {

$parcel$export(module.exports, "useTeamWebLinks", () => $e5eadcc240b15d46$export$72df01179a70062e);

var $iFWZA = parcelRequire("iFWZA");
var $4ZoIm = parcelRequire("4ZoIm");

var $asH6r = parcelRequire("asH6r");
const $e5eadcc240b15d46$var$initialState = {
    teamId: '',
    isLoading: false,
    hasLoaded: false,
    hasError: false,
    shouldReload: false,
    errorType: null,
    links: []
};
const $e5eadcc240b15d46$export$e324594224ef24da = {
    getTeamWebLinks: (teamId)=>async ({ getState: getState, setState: setState })=>{
            const { links: links, teamId: currentTeamId } = getState();
            const initialLinks = teamId === currentTeamId ? links : [];
            setState({
                teamId: teamId,
                isLoading: true,
                hasLoaded: false,
                hasError: false,
                shouldReload: false,
                links: initialLinks
            });
            try {
                const { entities: entities } = await (0, $asH6r.teamsClient).getTeamLinksByTeamId(teamId);
                if (getState().teamId !== teamId) return;
                setState({
                    isLoading: false,
                    hasLoaded: true,
                    hasError: false,
                    shouldReload: false,
                    links: entities
                });
            } catch (e) {
                if (getState().teamId !== teamId) return;
                setState({
                    isLoading: false,
                    hasLoaded: true,
                    hasError: true,
                    errorType: e instanceof Error ? e : undefined,
                    shouldReload: false,
                    links: []
                });
            }
        },
    createTeamWebLink: (teamId, newLink)=>async ()=>{
            return await (0, $asH6r.teamsClient).createTeamLink(teamId, newLink);
        },
    updateTeamWebLink: (teamId, linkId, newLink)=>async ()=>{
            return await (0, $asH6r.teamsClient).updateTeamLink(teamId, linkId, newLink);
        },
    removeWebLink: (teamId, linkId)=>async ({ dispatch: dispatch })=>{
            await (0, $asH6r.teamsClient).deleteTeamLink(teamId, linkId);
            await dispatch($e5eadcc240b15d46$export$e324594224ef24da.getTeamWebLinks(teamId));
        },
    initialState: (state)=>({ setState: setState })=>{
            setState({
                ...$e5eadcc240b15d46$var$initialState,
                ...state
            });
        }
};
const $e5eadcc240b15d46$var$TeamWebLinksStore = (0, $4ZoIm.createStore)({
    initialState: $e5eadcc240b15d46$var$initialState,
    actions: $e5eadcc240b15d46$export$e324594224ef24da
});
const $e5eadcc240b15d46$export$72df01179a70062e = (0, $iFWZA.createHook)($e5eadcc240b15d46$var$TeamWebLinksStore);
const $e5eadcc240b15d46$export$e1403f4f298df7e3 = (0, $iFWZA.createHook)($e5eadcc240b15d46$var$TeamWebLinksStore, {
    selector: null
});

});


parcelRegister("kcNH6", function(module, exports) {

$parcel$export(module.exports, "AddContainerCard", () => $9c9c7c8edc0a486e$export$7f436a9048e9eef4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $1qfLF = parcelRequire("1qfLF");

var $g5gZt = parcelRequire("g5gZt");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $31Vvl = parcelRequire("31Vvl");
const $9c9c7c8edc0a486e$var$styles = {
    card: "_4cvr1h6o _1bsb1osq",
    container: "_2rkoop52 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _d0altlke",
    iconWrapper: "_2rkoiti9 _12y3e4h9 _12jimuej _1qu2gq9o _syaz131l _4cvxmuej _ksodnqa1"
};
const $9c9c7c8edc0a486e$var$AddContainerCardWrapper = ({ children: children, onClick: onClick })=>{
    const [hovered, setHovered] = (0, $gwFzn.useState)(false);
    const handleMouseEnter = ()=>setHovered(true);
    const handleMouseLeave = ()=>setHovered(false);
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        backgroundColor: hovered ? 'elevation.surface.hovered' : 'elevation.surface.sunken',
        xcss: $9c9c7c8edc0a486e$var$styles.container,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: onClick,
        children: children
    });
};
const $9c9c7c8edc0a486e$export$7f436a9048e9eef4 = ({ containerType: containerType, onAddAContainerClick: onAddAContainerClick })=>{
    const { description: description, icon: icon, title: title } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        isEmptyContainer: true
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)($9c9c7c8edc0a486e$var$AddContainerCardWrapper, {
        onClick: onAddAContainerClick,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            space: "space.100",
            xcss: $9c9c7c8edc0a486e$var$styles.card,
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $9c9c7c8edc0a486e$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                        label: "Add a container",
                        appearance: "subtle",
                        icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g5gZt))), {
                                ...iconProps,
                                size: "small"
                            }),
                        testId: "add-icon",
                        onClick: (e)=>{
                            onAddAContainerClick(e);
                            e.stopPropagation();
                        }
                    })
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1s5hv.default), {
                            gap: "space.050",
                            alignItems: "center",
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                    size: "small",
                                    color: "color.text.subtle",
                                    children: description
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("31Vvl", function(module, exports) {

$parcel$export(module.exports, "getContainerProperties", () => $c54f7acfc778f2e2$export$4fa7913af1c65224);
/* get-container-properties.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $buthI = parcelRequire("buthI");

var $gj7hi = parcelRequire("gj7hi");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $iXCQx = parcelRequire("iXCQx");

var $gyIPW = parcelRequire("gyIPW");

var $4Qk2k = parcelRequire("4Qk2k");

var $erto5 = parcelRequire("erto5");

var $lJyfa = parcelRequire("lJyfa");

var $lkwpw = parcelRequire("lkwpw");
const $c54f7acfc778f2e2$var$styles = {
    iconWrapper: "_1bsb1crf _4t3i1crf",
    mediumIconWrapper: "_1bsb7vkz _4t3i7vkz",
    globeIconWrapper: "_2rko1sit _1bsb7vkz _4t3i7vkz _1e0c1txw _4cvr1h6o _1bah1h6o _12jimuej _1qu2nqa1"
};
const $c54f7acfc778f2e2$export$defe85febe8b728c = (0, $2nPZH.defineMessages)({
    addConfluenceContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-confluence-space-title.non-final",
        defaultMessage: "Add space"
    },
    confluenceContainerDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-confluence-space-description.non-final",
        defaultMessage: "Confluence"
    },
    addLoomContainerTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-title.non-final",
        defaultMessage: "Add space"
    },
    confluenceLoomDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-description.non-final",
        defaultMessage: "Loom"
    },
    addJiraProjectTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-jira-project-title.non-final",
        defaultMessage: "Add project"
    },
    jiraProjectDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-jira-project-description.non-final",
        defaultMessage: "Jira"
    },
    addLoomSpaceTitle: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-title.non-final",
        defaultMessage: "Add space"
    },
    loomSpaceDescription: {
        id: "ptc-directory.team-profile-page.team-containers.add-loom-space-description.non-final",
        defaultMessage: "Loom"
    },
    projectContainerText: {
        id: "ptc-directory.team-profile-page.team-containers.project-container-text.non-final",
        defaultMessage: "project"
    },
    spaceContainerText: {
        id: "ptc-directory.team-profile-page.team-containers.space-container-text.non-final",
        defaultMessage: "space"
    },
    emptyWebLinkContainerDescription: {
        id: "platform.teams.containers.empty-web-link-description.non-final",
        defaultMessage: "Add any web link"
    },
    webLinkContainerDescription: {
        id: "platform.teams.containers.web-link-title-description.non-final",
        defaultMessage: "Web link"
    }
});
const $c54f7acfc778f2e2$var$getJiraIcon = (containerSubTypes)=>{
    switch(containerSubTypes){
        case 'PRODUCT_DISCOVERY':
            return 0, (/*@__PURE__*/$parcel$interopDefault($erto5));
        case 'SERVICE_DESK':
            return 0, (/*@__PURE__*/$parcel$interopDefault($lJyfa));
        default:
            return 0, (/*@__PURE__*/$parcel$interopDefault($4Qk2k));
    }
};
const $c54f7acfc778f2e2$var$getJiraContainerProperties = ({ containerTypeProperties: containerTypeProperties, iconSize: iconSize = 'small' })=>{
    const { subType: subType, name: name } = containerTypeProperties || {};
    const baseProperties = {
        description: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.jiraProjectDescription
        }),
        icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
            xcss: iconSize === 'medium' ? $c54f7acfc778f2e2$var$styles.mediumIconWrapper : $c54f7acfc778f2e2$var$styles.iconWrapper,
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
                src: $c54f7acfc778f2e2$var$getJiraIcon(subType),
                alt: "",
                testId: "jira-project-container-icon"
            })
        }),
        title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.addJiraProjectTitle
        }),
        containerTypeText: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.projectContainerText
        })
    };
    switch(subType){
        case 'PRODUCT_DISCOVERY':
        case 'SERVICE_DESK':
            return {
                ...baseProperties,
                containerTypeText: '',
                description: name || baseProperties.description
            };
        default:
            return baseProperties;
    }
};
const $c54f7acfc778f2e2$var$getWebLinkContainerEmptyStateProperties = ({ isEmptyContainer: isEmptyContainer })=>{
    return {
        description: isEmptyContainer ? /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
            size: "medium",
            weight: "medium",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                ...$c54f7acfc778f2e2$export$defe85febe8b728c.emptyWebLinkContainerDescription
            })
        }) : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
            ...$c54f7acfc778f2e2$export$defe85febe8b728c.webLinkContainerDescription
        }),
        icon: isEmptyContainer ? null : /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
            xcss: $c54f7acfc778f2e2$var$styles.globeIconWrapper,
            testId: "team-link-card-globe-icon",
            children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($buthI))), {
                label: "",
                size: "small"
            })
        }),
        title: null,
        containerTypeText: null
    };
};
const $c54f7acfc778f2e2$export$4fa7913af1c65224 = ({ containerType: containerType, iconSize: iconSize = 'small', containerTypeProperties: containerTypeProperties, isEmptyContainer: isEmptyContainer })=>{
    switch(containerType){
        case 'ConfluenceSpace':
            return {
                description: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.confluenceContainerDescription
                }),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
                    xcss: iconSize === 'medium' ? $c54f7acfc778f2e2$var$styles.mediumIconWrapper : $c54f7acfc778f2e2$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($gyIPW))),
                        alt: "",
                        testId: "confluence-space-container-icon"
                    })
                }),
                title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addLoomContainerTitle
                }),
                containerTypeText: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerText
                })
            };
        case 'LoomSpace':
            return {
                description: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.loomSpaceDescription
                }),
                icon: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1s5hv.default), {
                    xcss: iconSize === 'medium' ? $c54f7acfc778f2e2$var$styles.mediumIconWrapper : $c54f7acfc778f2e2$var$styles.iconWrapper,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gj7hi.default), {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($lkwpw))),
                        alt: "",
                        testId: "confluence-space-container-icon"
                    })
                }),
                title: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.addConfluenceContainerTitle
                }),
                containerTypeText: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                    ...$c54f7acfc778f2e2$export$defe85febe8b728c.spaceContainerText
                })
            };
        case 'JiraProject':
            return $c54f7acfc778f2e2$var$getJiraContainerProperties({
                containerTypeProperties: containerTypeProperties,
                iconSize: iconSize
            });
        case 'WebLink':
            return $c54f7acfc778f2e2$var$getWebLinkContainerEmptyStateProperties({
                isEmptyContainer: isEmptyContainer
            });
        default:
            return {
                description: null,
                icon: null,
                title: null,
                containerTypeText: null
            };
    }
};

});
parcelRegister("gyIPW", function(module, exports) {
module.exports = new URL("ConfluenceIcon.3b027e05.svg", import.meta.url).toString();

});

parcelRegister("4Qk2k", function(module, exports) {
module.exports = new URL("JiraIcon.a06d5f95.svg", import.meta.url).toString();

});

parcelRegister("erto5", function(module, exports) {
module.exports = new URL("JiraProjectDiscovery.556db745.svg", import.meta.url).toString();

});

parcelRegister("lJyfa", function(module, exports) {
module.exports = new URL("JiraServiceManagement.0b0134a3.svg", import.meta.url).toString();

});

parcelRegister("lkwpw", function(module, exports) {
module.exports = new URL("LoomIcon.8c0f7a38.svg", import.meta.url).toString();

});



parcelRegister("iTmer", function(module, exports) {

$parcel$export(module.exports, "DisconnectDialogLazy", () => $c26279cf8f73c062$export$3f4d3ee9eb71a228);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $63PsS = parcelRequire("63PsS");

const $c26279cf8f73c062$var$DisconnectDialogLazyInner = (0, $63PsS.lazyForPaint)(()=>(parcelRequire("5nxS9")).then(({ DisconnectDialog: DisconnectDialog })=>DisconnectDialog));
const $c26279cf8f73c062$export$3f4d3ee9eb71a228 = (props)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $63PsS.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($c26279cf8f73c062$var$DisconnectDialogLazyInner, {
            ...props
        })
    });

});
parcelRegister("5nxS9", function(module, exports) {

let $3ea960115804a793$var$load = (parcelRequire("lhnSv"))(5);
module.exports = $3ea960115804a793$var$load("hfT7k").then(()=>parcelRequire('lvs8O'));

});
parcelRegister("lhnSv", function(module, exports) {
"use strict";


let $f7ddb539c5788a9e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("9WHwv")).shardUrl((parcelRequire("fzRTW")).resolve(id), maxShards));
    };
module.exports = $f7ddb539c5788a9e$var$load;

});
parcelRegister("9WHwv", function(module, exports) {

$parcel$export(module.exports, "shardUrl", () => $73db4aabb0664d41$export$2bf9932c19d6a5d2, (v) => $73db4aabb0664d41$export$2bf9932c19d6a5d2 = v);
$parcel$export(module.exports, "domainShardingKey", () => $73db4aabb0664d41$export$f6f4188f9108e61, (v) => $73db4aabb0664d41$export$f6f4188f9108e61 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73db4aabb0664d41$export$2bf9932c19d6a5d2;
var $73db4aabb0664d41$export$1d37a31d51d1e3ed;
var $73db4aabb0664d41$export$b4cd98d62f81485f;
var $73db4aabb0664d41$export$108ff8fc702e621f;
var $73db4aabb0664d41$export$f6f4188f9108e61;
"use strict";
let $73db4aabb0664d41$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 *
 * @param {string} pathname
 * @returns {string}
 */ function $73db4aabb0664d41$var$getFilenameFromUrlPath(pathname) {
    let lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 *
 * @param {string} str
 * @param {number} maxShards
 * @returns {number}
 */ function $73db4aabb0664d41$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    let totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        let n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
let $73db4aabb0664d41$var$trailingShardRegex = /-\d+$/;
/**
 * @param {string} subdomain
 */ function $73db4aabb0664d41$var$removeTrailingShard(subdomain) {
    if (!$73db4aabb0664d41$var$trailingShardRegex.test(subdomain)) return subdomain;
    let shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 *
 * @param {string} domain
 * @param {number} shard
 */ function $73db4aabb0664d41$var$applyShardToDomain(domain, shard) {
    let i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    let shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$73db4aabb0664d41$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    let firstSubdomain = $73db4aabb0664d41$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards) {
    let parsedUrl = new URL(url);
    let fileName = $73db4aabb0664d41$var$getFilenameFromUrlPath(parsedUrl.pathname);
    let shardNumber = $73db4aabb0664d41$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $73db4aabb0664d41$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 *
 * @param {string} url
 * @param {number} maxShards
 * @returns {string}
 */ function $73db4aabb0664d41$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$73db4aabb0664d41$var$globalKeyName]) return url;
    return $73db4aabb0664d41$var$shardUrlUnchecked(url, maxShards);
}
$73db4aabb0664d41$export$2bf9932c19d6a5d2 = $73db4aabb0664d41$var$shardUrl;
$73db4aabb0664d41$export$1d37a31d51d1e3ed = $73db4aabb0664d41$var$shardUrlUnchecked;
$73db4aabb0664d41$export$b4cd98d62f81485f = $73db4aabb0664d41$var$getDomainShardIndex;
$73db4aabb0664d41$export$108ff8fc702e621f = $73db4aabb0664d41$var$applyShardToDomain;
$73db4aabb0664d41$export$f6f4188f9108e61 = $73db4aabb0664d41$var$globalKeyName;

});

parcelRegister("fzRTW", function(module, exports) {

$parcel$export(module.exports, "register", () => $b573ef97cec72009$export$6503ec6e8aabbaf, (v) => $b573ef97cec72009$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $b573ef97cec72009$export$f7ad0328861e2f03, (v) => $b573ef97cec72009$export$f7ad0328861e2f03 = v);
var $b573ef97cec72009$export$6503ec6e8aabbaf;
var $b573ef97cec72009$export$f7ad0328861e2f03;
"use strict";
var $b573ef97cec72009$var$mapping = new Map();
function $b573ef97cec72009$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$b573ef97cec72009$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $b573ef97cec72009$var$resolve(id) {
    var resolved = $b573ef97cec72009$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$b573ef97cec72009$export$6503ec6e8aabbaf = $b573ef97cec72009$var$register;
$b573ef97cec72009$export$f7ad0328861e2f03 = $b573ef97cec72009$var$resolve;

});




parcelRegister("elYMw", function(module, exports) {

$parcel$export(module.exports, "LinkedContainerCard", () => $c099ef8fad4d3b86$export$139000e88c9ad830);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");

var $gwFzn = parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $dBxQj = parcelRequire("dBxQj");

var $inPa6 = parcelRequire("inPa6");

var $esRft = parcelRequire("esRft");

var $1qfLF = parcelRequire("1qfLF");

var $c6GJD = parcelRequire("c6GJD");

var $lnqHu = parcelRequire("lnqHu");

var $1bY7o = parcelRequire("1bY7o");

var $2Nwuj = parcelRequire("2Nwuj");

var $gdv5Z = parcelRequire("gdv5Z");
var $1s5hv = parcelRequire("1s5hv");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");
var $iXCQx = parcelRequire("iXCQx");

var $3gadb = parcelRequire("3gadb");

var $5KpJQ = parcelRequire("5KpJQ");

var $hbp6S = parcelRequire("hbp6S");

var $31Vvl = parcelRequire("31Vvl");
const $c099ef8fad4d3b86$var$messages = (0, $2nPZH.defineMessages)({
    disconnectTooltip: {
        id: "ptc-directory.team-containers.disconnect-button.tooltip",
        defaultMessage: "Disconnect"
    }
});
const $c099ef8fad4d3b86$var$styles = {
    container: "_2rkoop52 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _syaz1fxt",
    card: "_4cvr1h6o _1bsb1osq",
    iconWrapper: "_1bsbzwfg _4t3izwfg _1ul9zwfg _1tkezwfg",
    crossIconWrapper: "_1e0c1txw _4cvr1h6o _1bahesu3 _18u01wug",
    linkIconWrapper: "_2rkoop52 _1bsb1u1b _4t3i1u1b _1e0c1txw _4cvr1h6o _1bah1h6o _12jimuej _1qu2nqa1 _bfhkqbzx"
};
const $c099ef8fad4d3b86$var$isSupportingAddWebLink = (0, $c6GJD.default).initializeCompleted() && (0, $c6GJD.default).getExperimentValue('team_and_container_web_link', 'isEnabled', false);
const $c099ef8fad4d3b86$var$LinkedCardWrapper = ({ children: children, href: href, handleMouseEnter: handleMouseEnter, handleMouseLeave: handleMouseLeave, containerType: containerType, containerId: containerId })=>{
    const [hovered, setHovered] = (0, $gwFzn.useState)(false);
    const onMouseEnter = ()=>{
        handleMouseEnter();
        setHovered(true);
    };
    const { fireUIEvent: fireUIEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const onMouseLeave = ()=>{
        handleMouseLeave();
        setHovered(false);
    };
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        backgroundColor: hovered ? 'color.background.input.hovered' : 'color.background.input',
        xcss: $c099ef8fad4d3b86$var$styles.container,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        testId: "linked-container-card-inner",
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $2Nwuj.default), {
            href: href,
            appearance: "subtle",
            onClick: ()=>{
                fireUIEvent(createAnalyticsEvent, {
                    action: (0, $hbp6S.AnalyticsAction).CLICKED,
                    actionSubject: 'container',
                    actionSubjectId: 'teamContainer',
                    attributes: {
                        containerSelected: {
                            container: containerType,
                            containerId: containerId
                        }
                    }
                });
            },
            children: children
        })
    });
};
const $c099ef8fad4d3b86$var$getContainerIcon = (containerType, title, containerIcon)=>{
    if (containerType === 'LoomSpace') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $5KpJQ.LoomSpaceAvatar), {
        spaceName: title,
        size: 'large'
    });
    if ($c099ef8fad4d3b86$var$isSupportingAddWebLink && containerType === 'WebLink') return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $c099ef8fad4d3b86$var$styles.linkIconWrapper,
        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1bY7o))), {
            label: ""
        })
    });
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $esRft.default), {
        appearance: "square",
        size: "medium",
        src: containerIcon,
        testId: "linked-container-icon"
    });
};
const $c099ef8fad4d3b86$export$139000e88c9ad830 = ({ containerType: containerType, title: title, containerIcon: containerIcon, link: link, containerId: containerId, containerTypeProperties: containerTypeProperties, onDisconnectButtonClick: onDisconnectButtonClick })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const { description: description, icon: icon, containerTypeText: containerTypeText } = (0, $31Vvl.getContainerProperties)({
        containerType: containerType,
        iconSize: 'small',
        containerTypeProperties: containerTypeProperties
    });
    const [showCloseIcon, setShowCloseIcon] = (0, $gwFzn.useState)(false);
    const { formatMessage: formatMessage } = (0, $dBxQj.default)();
    const { fireUIEvent: fireUIEvent } = (0, $hbp6S.usePeopleAndTeamAnalytics)();
    return /*#__PURE__*/ (0, $7UHDa.jsx)($c099ef8fad4d3b86$var$LinkedCardWrapper, {
        href: link || '#',
        handleMouseEnter: ()=>setShowCloseIcon(true),
        handleMouseLeave: ()=>setShowCloseIcon(false),
        containerType: containerType,
        containerId: containerId,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            space: "space.100",
            xcss: $c099ef8fad4d3b86$var$styles.card,
            children: [
                $c099ef8fad4d3b86$var$getContainerIcon(containerType, title, containerIcon),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                            maxLines: 1,
                            weight: "medium",
                            color: "color.text",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $1s5hv.default), {
                            gap: "space.050",
                            alignItems: "center",
                            children: [
                                icon,
                                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
                                    space: "space.050",
                                    children: [
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            color: "color.text.subtle",
                                            children: description
                                        }),
                                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $iXCQx.default), {
                                            size: "small",
                                            color: "color.text.subtle",
                                            children: containerTypeText
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                showCloseIcon && /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $c099ef8fad4d3b86$var$styles.crossIconWrapper,
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $3gadb.default), {
                        content: formatMessage($c099ef8fad4d3b86$var$messages.disconnectTooltip),
                        position: "top",
                        children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $1qfLF.default), {
                            label: `disconnect the container ${title}`,
                            appearance: "subtle",
                            icon: (iconProps)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lnqHu))), {
                                    ...iconProps,
                                    size: "small"
                                }),
                            spacing: "compact",
                            onClick: (e)=>{
                                e.preventDefault();
                                e.stopPropagation();
                                onDisconnectButtonClick();
                                fireUIEvent(createAnalyticsEvent, {
                                    action: (0, $hbp6S.AnalyticsAction).CLICKED,
                                    actionSubject: 'button',
                                    actionSubjectId: 'containerUnlinkButton'
                                });
                            }
                        })
                    })
                })
            ]
        })
    });
};

});
parcelRegister("5KpJQ", function(module, exports) {

$parcel$export(module.exports, "LoomSpaceAvatar", () => $a45374652d92ddd7$export$6055fe3c3d07f8d9);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $35pXk = parcelRequire("35pXk");

var $eBZZo = parcelRequire("eBZZo");
const $a45374652d92ddd7$var$boxStyle = null;
const $a45374652d92ddd7$var$smallBoxStyle = null;
const $a45374652d92ddd7$var$largeBoxStyle = null;
function $a45374652d92ddd7$export$6055fe3c3d07f8d9({ spaceName: spaceName = '', size: size = 'small' }) {
    const avatarText = (0, $eBZZo.getAvatarText)(spaceName);
    const containerColor = (0, $eBZZo.pickContainerColor)(spaceName);
    const textColor = (0, $eBZZo.pickTextColor)(spaceName);
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        style: {
            backgroundColor: containerColor,
            color: textColor
        },
        className: (0, $35pXk.default)([
            "_2rkoiti9 _189ee4h9 _1dqonqa1 _1h6dmuej _1e0c1txw _4cvr1h6o _1bah1h6o",
            size === 'small' ? "_11c8140y _4t3i1tcg _1bsb1tcg" : "_11c8lodh _4t3izwfg _1bsbzwfg"
        ]),
        children: avatarText
    });
}

});
parcelRegister("eBZZo", function(module, exports) {

$parcel$export(module.exports, "getAvatarText", () => $e0c49377f9432a00$export$a3b2d23d4cacf752);
$parcel$export(module.exports, "pickContainerColor", () => $e0c49377f9432a00$export$55185ae96e679e0a);
$parcel$export(module.exports, "pickTextColor", () => $e0c49377f9432a00$export$7063fff24f5d2ae7);

var $hbM72 = parcelRequire("hbM72");
var $e0c49377f9432a00$var$SpaceColors = /*#__PURE__*/ function(SpaceColors) {
    SpaceColors["ORANGE_LIGHT"] = "#FFD5D2";
    SpaceColors["BLUE_LIGHT"] = "#CFE1FD";
    SpaceColors["YELLOW_LIGHT"] = "#FCE4A6";
    SpaceColors["TEAL"] = "#BAF3DB";
    return SpaceColors;
}($e0c49377f9432a00$var$SpaceColors || {});
var $e0c49377f9432a00$var$AvatarTextColors = /*#__PURE__*/ function(AvatarTextColors) {
    AvatarTextColors["ORANGE_DARK"] = "#AE2E24";
    AvatarTextColors["BLUE_DARK"] = "#123263";
    AvatarTextColors["YELLOW_DARK"] = "#9E4C00";
    AvatarTextColors["TEAL_DARK"] = "#164B35";
    return AvatarTextColors;
}($e0c49377f9432a00$var$AvatarTextColors || {});
const $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS = [
    "#FFD5D2",
    "#CFE1FD",
    "#FCE4A6",
    "#BAF3DB"
];
const $e0c49377f9432a00$var$AVATAR_TEXT_COLORS = [
    "#AE2E24",
    "#123263",
    "#9E4C00",
    "#164B35"
];
const $e0c49377f9432a00$var$hash = (str)=>{
    let hash = $hbM72(str);
    hash = ~hash;
    return Math.abs(Number(hash));
};
const $e0c49377f9432a00$export$a3b2d23d4cacf752 = (spaceName)=>{
    return spaceName?.trim().length ? spaceName.trim()[0].toUpperCase() : '';
};
const $e0c49377f9432a00$export$55185ae96e679e0a = (spaceName)=>{
    const avatarHash = $e0c49377f9432a00$var$hash(spaceName);
    return $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS[avatarHash % $e0c49377f9432a00$var$AVATAR_CONTAINER_COLORS.length];
};
const $e0c49377f9432a00$export$7063fff24f5d2ae7 = (spaceName)=>{
    const avatarHash = $e0c49377f9432a00$var$hash(spaceName);
    return $e0c49377f9432a00$var$AVATAR_TEXT_COLORS[avatarHash % $e0c49377f9432a00$var$AVATAR_TEXT_COLORS.length];
};

});
parcelRegister("hbM72", function(module, exports) {
"use strict";
function $c838c8e58899ac9a$var$hash(str) {
    var hash = 5381, i = str.length;
    while(i)hash = hash * 33 ^ str.charCodeAt(--i);
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
   * integers. Since we want the results to be always positive, convert the
   * signed int to an unsigned by doing an unsigned bitshift. */ return hash >>> 0;
}
module.exports = $c838c8e58899ac9a$var$hash;

});




parcelRegister("fZVE2", function(module, exports) {

$parcel$export(module.exports, "NoProductAccessState", () => $3dedcd9c7ca34a19$export$ecd1a08b364becd6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $2nPZH = parcelRequire("2nPZH");
var $4jR19 = parcelRequire("4jR19");

var $7hXDW = parcelRequire("7hXDW");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");

var $ke0xy = parcelRequire("ke0xy");
const $3dedcd9c7ca34a19$var$styles = {
    emptyStateContainer: "_2rkoiti9 _189ee4h9 _1h6dmuej _18zrxy5q _12y3e4h9 _12jimuej _1qu2nqa1",
    contentWrapper: "_bozgxy5q"
};
const $3dedcd9c7ca34a19$export$ecd1a08b364becd6 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $eyWa4.default), {
        space: "space.100",
        xcss: $3dedcd9c7ca34a19$var$styles.emptyStateContainer,
        testId: "team-containers-no-product-access-state",
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $ke0xy.NoProductAccessIcon), {}),
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    xcss: $3dedcd9c7ca34a19$var$styles.contentWrapper,
                    children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                        space: "space.100",
                        children: [
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $7hXDW.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                    ...$3dedcd9c7ca34a19$var$messages.teamContainerEmptyStateTitle
                                })
                            }),
                            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $4jR19.default), {
                                ...$3dedcd9c7ca34a19$var$messages.teamContainerEmptyStateDescription
                            })
                        ]
                    })
                })
            ]
        })
    });
};
const $3dedcd9c7ca34a19$var$messages = (0, $2nPZH.defineMessages)({
    teamContainerEmptyStateTitle: {
        id: "ptc.team-profile-page.team-containers.empty-state.title",
        defaultMessage: "Add the places your team works"
    },
    teamContainerEmptyStateDescription: {
        id: "ptc.team-profile-page.team-containers.empty-state.description",
        defaultMessage: "Your team can link their Jira projects, Confluence spaces here to show where they work"
    }
});

});
parcelRegister("ke0xy", function(module, exports) {

$parcel$export(module.exports, "NoProductAccessIcon", () => $536c25e2a1eaecbd$export$bf513868cd2f920f);

var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");
function $536c25e2a1eaecbd$var$TeamContainersNoProductAccess() {
    return /*#__PURE__*/ (0, $7UHDa.jsxs)("svg", {
        width: "180",
        height: "170",
        viewBox: "0 0 180 170",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M65.004 40.9222L33.3022 45.8529L38.2329 77.5546L118.928 65.004L115.791 44.8301L78.3249 50.6572L65.004 40.9222Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M120.273 73.6499L39.5776 86.2006L45.8529 126.548L126.548 113.998L120.273 73.6499Z",
                fill: "#1868DB"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsxs)("g", {
                clipPath: "url(#clip0_5508_39188)",
                children: [
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M129.406 142.298C120.375 151.329 105.733 151.329 96.7018 142.298C87.671 133.267 87.671 118.626 96.7018 109.595L104.878 101.419L111.419 107.959L103.243 116.135C97.8241 121.554 97.8241 130.339 103.243 135.757C108.661 141.176 117.446 141.176 122.865 135.757L131.041 127.582L137.581 134.122L129.406 142.298Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M152.298 119.406C161.329 110.375 161.329 95.7328 152.298 86.7019C143.267 77.6711 128.625 77.6711 119.594 86.7019L111.418 94.8779L117.959 101.419L126.135 93.2427C131.553 87.8242 140.339 87.8242 145.757 93.2427C151.176 98.6612 151.176 107.446 145.757 112.865L137.581 121.041L144.122 127.582L152.298 119.406Z",
                        fill: "#FCA700"
                    }),
                    /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M139.449 106.092L116.324 129.217L109.783 122.676L132.908 99.5512L139.449 106.092Z",
                        fill: "#FCA700"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.784 117.729L90.8252 119.434C91.8704 115.787 93.8291 112.347 96.7015 109.475L104.877 101.299L111.418 107.84L103.242 116.016C102.702 116.556 102.216 117.129 101.784 117.729ZM125.459 106.88L126.548 113.878L116.972 115.367L125.459 106.88ZM121.979 84.5L123.699 95.5589L117.959 101.299L111.418 94.7581L119.594 86.5822C120.352 85.8246 121.149 85.1305 121.979 84.5Z",
                fill: "#09326C"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("path", {
                d: "M147.591 62.1215C147.471 62.5353 147.38 62.9491 147.239 63.3629C146.689 65.0183 145.949 66.7017 144.779 68.2518C143.63 69.8019 141.847 71.1485 139.838 71.6886C137.837 72.2498 135.835 72.1025 134.073 71.6886C130.528 70.8329 127.687 69.1005 125.178 67.375H125.249V67.3329C125.798 67.5293 127.25 68.2798 128.639 68.855C130.013 69.4582 131.324 69.872 131.324 69.872C129.675 68.5323 127.871 67.5363 125.968 66.4982C124.079 65.4672 122.133 64.401 120.512 63.0613L120.329 63.3419C121.753 64.4922 122.986 65.5654 123.444 66.0704C120.59 64.3449 116.678 61.2517 113.154 57.871C112.266 57.0293 111.406 56.1735 110.575 55.3248C110.391 55.1355 110.081 54.8198 110.138 54.8759C110.138 54.8759 110.123 54.8619 110.088 54.8479L109.961 54.7707L109.616 54.5673C109.158 54.2938 108.707 54.0202 108.27 53.7607C107.819 53.5362 107.382 53.3188 106.952 53.1084C106.74 53.0032 106.529 52.8839 106.325 52.7997C106.113 52.7156 105.909 52.6385 105.704 52.5613C105.303 52.414 104.915 52.2246 104.541 52.1054C104.168 51.9931 103.815 51.8949 103.484 51.7967C103.576 51.6845 104.02 51.8599 104.513 51.9581C104.999 52.0703 105.535 52.2246 105.888 51.895L104.837 51.5162C104.478 51.425 104.125 51.3409 103.773 51.2497L103.244 51.1164C103.068 51.0743 102.892 51.0743 102.716 51.0533C102.363 51.0252 102.018 50.9901 101.673 50.9621C101.673 51.5022 102.434 51.3759 102.582 51.4811C102.434 51.5092 102.117 51.5232 101.659 51.5162C101.433 51.5372 101.179 51.5863 100.89 51.6214C100.601 51.6635 100.277 51.6705 99.953 51.7897C98.6068 52.0843 96.9787 52.926 95.703 54.5743C94.4555 56.2437 93.645 58.6986 93.6309 61.3289C93.6309 62.6335 93.7507 63.9872 94.1172 65.2708L94.237 65.7548L94.4062 66.2247C94.5189 66.5333 94.6176 66.856 94.7445 67.1646C95.0334 67.7538 95.2731 68.378 95.6325 68.9111C96.2598 70.0474 97.1056 71.0013 97.9725 71.843C98.4518 72.2147 98.8535 72.6566 99.361 72.9442C99.6006 73.1055 99.8402 73.2668 100.073 73.4211C100.305 73.5824 100.573 73.6806 100.813 73.8139C101.06 73.9402 101.299 74.0664 101.532 74.1856C101.778 74.2908 102.032 74.368 102.272 74.4662C102.751 74.6486 103.216 74.845 103.681 74.9361C104.147 75.0484 104.577 75.1887 104.992 75.2728C105.415 75.343 105.817 75.4061 106.177 75.4622C106.902 75.6235 107.53 75.6165 107.988 75.7077C108.453 75.7779 108.756 75.862 108.883 75.9602C109.123 76.1566 108.629 76.4021 107.072 76.7177L107.389 76.9913C104.147 77.0684 101.412 76.6476 98.1346 75.2167C97.7329 74.9081 97.6554 74.9221 97.8175 74.6977C97.7329 74.5925 97.599 74.4101 97.7117 74.347C98.1417 73.835 97.1902 73.3931 96.8448 73.0845C96.725 73.3159 96.4994 73.4071 96.2105 73.337C95.9285 73.2598 95.5762 73.0353 95.1744 72.7057C94.7515 72.3971 94.3991 71.878 93.9833 71.3449C93.7648 71.0784 93.6097 70.7628 93.4335 70.4472C93.2644 70.1245 93.0741 69.8089 92.9261 69.4582C92.6582 68.7568 92.3552 68.0554 92.2142 67.3329C92.1296 66.9752 92.0309 66.6315 91.9746 66.2948C91.9252 65.9511 91.8829 65.6215 91.8406 65.3129C91.7067 64.0644 91.7067 63.0894 91.6856 62.7247C91.1922 62.6195 91.0795 61.8619 91.2134 61.0483C91.2768 60.2277 91.5658 59.3719 91.4178 58.888C91.3755 58.9441 91.0865 59.3159 91.0512 59.365C90.9878 59.2527 90.9808 58.9371 91.0442 58.4882C91.1429 58.0463 91.2698 57.4641 91.5023 56.8188C91.9605 55.5353 92.8485 54.0483 93.8987 52.919C94.1736 52.6525 94.4414 52.386 94.6952 52.1334C94.9841 51.916 95.2519 51.7126 95.5057 51.5232C95.6325 51.425 95.7524 51.3409 95.8651 51.2497C95.992 51.1795 96.1118 51.1094 96.2246 51.0462C96.4501 50.92 96.6475 50.8007 96.8025 50.7026C97.1127 50.4851 97.31 50.3939 97.2818 50.3238C97.2536 50.2607 96.9999 50.2256 96.4924 50.3659C98.2051 49.0613 100.714 48.3809 103.244 48.5843C105.789 48.7596 108.312 49.6645 110.687 50.899C110.983 51.0603 111.272 51.2216 111.575 51.3829L112.019 51.6284C112.217 51.7406 112.485 51.8599 112.675 52.0913C113.154 52.5613 113.633 53.0382 114.12 53.5152C115.05 54.42 115.987 55.3318 116.953 56.2367C118.877 58.0533 120.886 59.8489 122.972 61.5463C125.065 63.2297 127.243 64.8149 129.506 66.0984C130.64 66.7297 131.796 67.2838 132.952 67.7257C134.115 68.1395 135.278 68.4271 136.392 68.5253C138.626 68.6586 140.508 67.873 141.629 66.2597C142.235 65.5163 142.636 64.5694 142.975 63.6576C143.144 63.1946 143.243 62.6966 143.369 62.2337C143.44 62.0092 143.475 61.7567 143.51 61.5182L143.567 61.1605L143.595 60.9852L143.609 60.894C143.609 60.894 143.609 60.894 143.602 60.887C143.637 60.908 143.687 60.887 143.708 60.9501C143.687 60.887 143.75 60.887 143.602 60.88C143.658 60.88 143.708 60.8659 143.743 60.8379C143.743 60.8239 143.771 60.8379 143.764 60.7958C143.75 60.7327 143.736 60.6625 143.722 60.5994C143.687 60.4661 143.658 60.3259 143.616 60.1856C143.433 59.6315 143.243 59.0142 142.989 58.4671C142.524 57.3589 141.995 56.4751 141.995 56.4751C141.311 55.1845 140.501 53.922 139.641 52.6735C139.641 52.6735 139.303 52.3158 138.76 51.7406C138.217 51.1585 137.47 50.3659 136.681 49.419C135.898 48.4791 135.074 47.3919 134.489 46.2206C133.904 45.0632 133.594 43.8147 133.699 42.9099C133.516 41.8157 133.615 40.6795 133.925 39.6274C134.101 39.1153 134.277 38.5893 134.538 38.1193C134.757 37.6213 135.053 37.1865 135.335 36.7376C136.497 34.97 137.949 33.4901 139.444 32.0943C139.444 32.0943 139.493 32.0592 139.556 32.0031C139.859 32.0031 140.177 32.0311 140.395 32.1153C140.36 31.975 140.48 31.989 140.494 31.9399L140.508 32.0592C140.874 31.6804 141.304 31.3437 141.769 31.0491C141.72 30.9159 141.699 30.8317 141.713 30.8247C140.007 30.3688 135.37 31.8347 134.066 30.7335L131.606 31.3157C130.612 30.8738 129.4 30.7125 129.802 30.1022C130.204 29.492 141.565 27.2265 144.709 28.2716L144.673 28.2926C144.673 28.2926 145.667 28.5171 145.639 28.3908C146.118 30.5582 146.915 33.5882 145.801 35.6363C146.069 36.3728 144.342 46.6695 142.51 43.934C142.721 42.2647 142.601 40.1815 142.721 38.5261C142.763 36.8498 142.721 34.7806 142.672 33.2305C142.672 33.2305 142.665 33.2095 142.651 33.1814C142.629 33.2235 142.615 33.2586 142.622 33.2796C140.578 34.6333 138.823 36.3728 137.675 38.2456C137.09 39.1784 136.73 40.1394 136.596 40.9951C136.469 41.8578 136.568 42.6153 136.871 43.5131C136.66 43.5412 136.554 43.7166 136.709 43.7937L136.927 43.6604C137.209 44.9721 138.076 46.0101 138.908 46.9781C139.754 47.9601 140.628 48.9561 141.333 50.4641C141.333 50.4571 141.347 49.9731 141.347 49.9591C143.109 52.0493 145.089 54.5042 146.626 57.4641C146.809 57.8359 146.992 58.2146 147.182 58.5934C147.394 59.0984 147.605 59.6104 147.817 60.1224C147.873 60.2908 147.979 60.4591 148 60.6345L147.859 61.1675L147.605 62.1074L147.591 62.1215Z",
                fill: "#101214"
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7UHDa.jsx)("clipPath", {
                    id: "clip0_5508_39188",
                    children: /*#__PURE__*/ (0, $7UHDa.jsx)("rect", {
                        width: "111",
                        height: "111",
                        fill: "white",
                        transform: "translate(69 59)"
                    })
                })
            })
        ]
    });
}
function $536c25e2a1eaecbd$export$bf513868cd2f920f() {
    return /*#__PURE__*/ (0, $7UHDa.jsx)("div", {
        children: /*#__PURE__*/ (0, $7UHDa.jsx)($536c25e2a1eaecbd$var$TeamContainersNoProductAccess, {})
    });
}

});


parcelRegister("e9UQf", function(module, exports) {

$parcel$export(module.exports, "TeamContainersSkeleton", () => $077b7b532f737b9b$export$b4d5d8f3bbe29b5f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $d8SNb = parcelRequire("d8SNb");
var $eyWa4 = parcelRequire("eyWa4");

var $5g9Fc = parcelRequire("5g9Fc");
const $077b7b532f737b9b$var$styles = {
    containers: "_yv0ewxkt",
    showMoreButtonSkeleton: "_2rko1q77 _1rjc1b66 _1bsbvbgk"
};
const $077b7b532f737b9b$export$b4d5d8f3bbe29b5f = ({ numberOfContainers: numberOfContainers })=>{
    return /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
        space: "space.200",
        testId: "team-containers-skeleton",
        children: [
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $d8SNb.default), {
                xcss: $077b7b532f737b9b$var$styles.containers,
                gap: "space.100",
                autoFlow: "row",
                children: [
                    ...Array(numberOfContainers)
                ].map((_, index)=>/*#__PURE__*/ (0, $7UHDa.jsx)((0, $5g9Fc.LinkedContainerCardSkeleton), {}, index))
            }),
            /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                backgroundColor: "color.background.neutral",
                xcss: $077b7b532f737b9b$var$styles.showMoreButtonSkeleton
            })
        ]
    });
};

});
parcelRegister("5g9Fc", function(module, exports) {

$parcel$export(module.exports, "LinkedContainerCardSkeleton", () => $57ec3d96dbbf3c78$export$b7a75d9378054329);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $7UHDa = parcelRequire("7UHDa");
parcelRequire("gwFzn");

var $gdv5Z = parcelRequire("gdv5Z");
var $u9agA = parcelRequire("u9agA");
var $eyWa4 = parcelRequire("eyWa4");
const $57ec3d96dbbf3c78$var$styles = {
    container: "_2rkoiti9 _1h6dz9xs _12y3e4h9 _12jimuej _1qu2nqa1 _syaz1fxt _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    avatarSkeleton: "_2rkoglpi _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    firstLineSkeleton: "_2rko1q77 _1rjc1b66",
    secondLineSkeleton: "_2rko1q77 _1rjc1b66 _1bsbqkoa"
};
const $57ec3d96dbbf3c78$export$b7a75d9378054329 = ()=>{
    return /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
        xcss: $57ec3d96dbbf3c78$var$styles.container,
        children: /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $u9agA.default), {
            space: "space.100",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                    backgroundColor: "color.background.neutral",
                    xcss: $57ec3d96dbbf3c78$var$styles.avatarSkeleton
                }),
                /*#__PURE__*/ (0, $7UHDa.jsxs)((0, $eyWa4.default), {
                    space: "space.100",
                    grow: "fill",
                    children: [
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $57ec3d96dbbf3c78$var$styles.firstLineSkeleton
                        }),
                        /*#__PURE__*/ (0, $7UHDa.jsx)((0, $gdv5Z.default), {
                            backgroundColor: "color.background.neutral",
                            xcss: $57ec3d96dbbf3c78$var$styles.secondLineSkeleton
                        })
                    ]
                })
            ]
        })
    });
};

});




//# sourceMappingURL=SpaceOverview.57350bfe.js.map
